/*!
=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================
* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Pagination,
  Col,
  Table,
  OverlayTrigger,
  ControlLabel,
  FormGroup,
  FormControl,
  Modal,
  Tooltip,
} from "react-bootstrap";
import {
  updateOrdersRider,
  Updatereview,
  getallrider,
  ChargeOrder,
  getallCurrier,
  updateOrderStatus,
  searchOrders,
  DeleteOrder,
  DownloadOrder,
  updatepaymentinfo,
  getCity,
  getb2b,
  sendNotificationSMS,
  get_normal_pending_order,
  get_express_pending_order,
  getOrderById,
  getb2bdetail,
  SendB2bEmailNotification,
  getSalesRepresentative,
  getBrachDetailsCountryCodeWise,
  Get_Settings,
  getOrganizationDataWithoutPagination,
  submitInsuremeClaimConfirmation,
  insuremeUploadDocument,
  submitInsuremeClaimRequest,
  allocationValuePopUp,
} from "../../../Listfunction";
// react component that creates a switch button that changes from on to off mode
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import { Link, withRouter } from "react-router-dom";
import ReactTable from "react-table";
import DatePicker from "react-datepicker";
import Datetime from "react-datetime";
import { Collapse } from "react-collapse";
import "react-datepicker/dist/react-datepicker.css";
import Switch from "react-bootstrap-switch";
import SweetAlert from "react-bootstrap-sweetalert";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import Select from "react-select";
import Card from "components/Card/Card.jsx";
import LoadingSpinner from "views/Components/loadingSpinner";
import LoadingPdfSpinner from "views/Components/loadingPdfSpinner";
import Button from "components/CustomButton/CustomButton.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";
import originalMoment from "moment";
import { extendMoment } from "moment-range";
import ScreenLoader from "views/Components/screenLoader";
import { darkula } from "react-syntax-highlighter/dist/styles/hljs";
import EmailMultiValueTextInput from "./EmailMultiValueTextInput";
import { getFileExtensionFromMimeType } from "utils/getFileExtensionFromMimeType";
import OrderSelectionModal from "./pickUpModal/orderSelectionModal.jsx";
const moment = extendMoment(originalMoment);
const today = moment();

export const CheckBox = (props) => {
  return (
    <li>
      <input
        key={props.id}
        onClick={props.handleCheckChieldElement}
        type="checkbox"
        checked={props.isChecked}
        value={props.value}
      />{" "}
      {props.value}
    </li>
  );
};
class viewOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validityDate: "",
      validityDateError: null,
      pdfloading: false,
      order_details: [],
      order_chk: [],
      selected_id: [],
      order_info: [],
      loading: false,
      bulkSelect: null,
      subscriber: "",
      rider_id: "",
      currier_id: null,
      is_currier: null,
      source: "",
      status: "",
      page: "",
      paginationData: [],
      show_charge_message: false,
      charge_message: "",
      noRecordFound: false,
      nextpage: "",
      city_info: [],
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      deliveryType: "",
      alert: null,
      viewinvoice: "",
      useraccess: "",
      orderdate: "",
      processing: true,
      smsMessage: "",
      showSmsMessageModal: false,
      btn_disabled: true,
      channel_filter: "",
      order_type_filter: "",
      order_id_filter: "",
      po_number: "",
      fromdate_filter: "",
      todate_filter: "",
      todateerror: null,
      p_orderid: "",
      p_orderdata: [],
      chargeProcessing: false,
      p_total_cost: "",
      p_paid_amount: "",
      showpaymentdetailmodal: false,
      shownotificationmodal: false,
      _notificationSystem: null,
      paymenttype: "",
      f_paymenttype: "",
      remainpaymentamount: "0",
      paidamount: 0,
      errormessages: [],
      cancelorderModal: false,
      supplierModal: false,
      ridermodel: false,
      ordercancelreason: "",
      paymentoption: "",
      city_id: 0,
      notificationtype: "delay",
      cancel_reason_display_Modal: false,
      Cancel_reason_state: "",
      Cancel_message_state: "",
      cancel_message: "",
      ordercancelreasonError: null,
      rider_details: [],
      currier_details: [],
      b2b: "",
      organization_id: "0",
      b2bDetails: [],
      rider_info: null,
      rider_infoError: null,
      currier_idError: null,
      rider_data: [],
      currier_data: [],
      value: "",
      isdaterangepickerOpen: false,
      rider_details: [],
      time: "",
      currier_disabled: "yes",
      btn_text: "Submit",
      htmlContent: "",
      delivery_from_date: "",
      // notedisplay: [],
      viewMedDetails: true,
      normal_data: [],
      express_data: [],
      is_checked: [],
      isLoading: false,
      courier_partner: "",
      is_courier_partner: 0,
      tracking_id: "",
      tracking_url: "",
      tracking_note: "",
      order_b2bcontact_details: [],
      // alert: null,
      medicationListing: [],
      salesAgentOptions: [],
      salesAgentValue: "",
      showOutOfStock: false,
      datarange: moment.range(today.clone(), today.clone().add(7, "days")),
      fruites: [
        { id: 1, value: "banana", isChecked: false },
        { id: 2, value: "apple", isChecked: false },
        { id: 3, value: "mango", isChecked: false },
        { id: 4, value: "grap", isChecked: false },
      ],
      b2bEmail: [],
      branchList: [],
      branch: "",
      settingsData: "",
      userData: "",
      checkedElement: [],
      district: "",
      orderSubType: "",
      textFields: [],
      allRiderData: [],
      partial_sent: false,
      selectedOrderData: null,
      insuremeBannerText: null,
      resultCount: 0,
      current: 0,
      pageSize: 10,
      is_claimable: 0,
      isDisableChangeStatusButton: false,
      StoreManager: "",
      store: "",
      showModal: false,
      delivery_Type: "",
      cancelModalTitle: "Cancel Order",
      cancelModalLabel: "Cancel Order Reason",
    };
    this.onStatusChange = this.onStatusChange.bind(this);
    this.editOrder = this.editOrder.bind(this);
    this.editOrderNew = this.editOrderNew.bind(this);
    this.cancellationOrder = this.cancellationOrder.bind(this);
    this.replicateOrder = this.replicateOrder.bind(this);
    this.completeOrderOnOneClcik = this.completeOrderOnOneClcik.bind(this);
    this.handleCompleteOrderOneClick =
      this.handleCompleteOrderOneClick.bind(this);
    this.addorder = this.addorder.bind(this);
    this.addOrderNew = this.addOrderNew.bind(this);
    this.NavigateToCreateLeads = this.NavigateToCreateLeads.bind(this);
    this.searchData = this.searchData.bind(this);
    this.searchdata = this.searchdata.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.onChange = this.onChange.bind(this);
    this.getdata = this.getdata.bind(this);
    // this.collapsing = this.collapsing.bind(this);
    this.deleteorderdetails = this.deleteorderdetails.bind(this);
    this.handleUpdateStatus = this.handleUpdateStatus.bind(this);
    this.warningWithConfirmAndCancelMessage =
      this.warningWithConfirmAndCancelMessage.bind(this);
    this.downloadinvoice = this.downloadinvoice.bind(this);
    this.viewpdf = this.viewpdf.bind(this);
    this.onpaymentchange = this.onpaymentchange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    // this.handleDateChange1 = this.handleDateChange1.bind(this);
    this.downloadpre = this.downloadpre.bind(this);
    this.oncancelchnage = this.oncancelchnage.bind(this);
    this.sendB2bEmail = this.sendB2bEmail.bind(this);
    this.handleCreateToken = this.handleCreateToken.bind(this);
  }
  handleMultiTextField(val) {
    this.setState({
      b2bEmail: val,
    });
  }
  qualitychecked = (e, id) => {
    var checked = e.target.checked;
    var chk_arr = this.state.is_checked;
    chk_arr[id] = checked;
    var chk_st = false;
    chk_arr.map((x) => {
      if (x == false) {
        chk_st = true;
      }
    });
    if (chk_st) {
      this.setState({ btn_disabled: true });
    } else {
      this.setState({ btn_disabled: false });
    }
    this.setState({ is_checked: chk_arr });
  };
  isCurrier = (e) => {
    var checked = e.target.checked;
    if (checked) {
      this.setState({
        currier_disabled: "no",
        is_currier: checked,
        rider_info: null,
      });
    } else {
      this.setState({
        currier_disabled: "yes",
        tracking_id: "",
        tracking_note: "",
        tracking_url: "",
        currier_id: null,
        is_currier: checked,
      });
    }
  };

  isCurrierPartner = (e) => {
    var checked = e.target.checked;
    this.setState({
      is_courier_partner: checked,
      rider_id: "",
      courier_partner: "",
    });
  };

  isPartialTrue = (e) => {
    var checked = e.target.checked;
    this.setState({
      partial_sent: checked,
      rider_id: "",
      courier_partner: "",
      city_id: "",
      is_courier_partner: null,
    });
  };

  isClaimableTrue = (e) => {
    const checked = e.target.checked;
    this.setState({
      is_claimable: checked ? "1" : "0",
    });
  };

  chargeSubscription(id) {
    this.setState({
      chargeProcessing: true,
      isLoading: true,
    });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    ChargeOrder(id, obj)
      .then((res) => {
        this.setState({
          alert: null,
        });
        this.setState({
          show_charge_message: true,
          charge_message: res.data.message,
          chargeProcessing: false,
          isLoading: false,
        });

        this.searchData();
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        this.handleNetworkError("bl");
      });
  }
  warningWithChargeMessage(id) {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.chargeSubscription(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, charge it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will charge for that Order now !
        </SweetAlert>
      ),
    });
  }
  handleDateChange = (date) => {
    this.setState({
      orderdate: date,
    });
  };

  onSelect = (value, states) => {
    this.setState({ value, states });
  };
  onToggle() {
    this.setState({
      isdaterangepickerOpen: !this.state.isdaterangepickerOpen,
      isdatepickeron: !this.state.isdatepickeron,
    });
  }

  open_cancel_reason_display_Modal(cancel_reason, cancel_message) {
    this.setState({
      cancel_reason_display_Modal: true,
      Cancel_reason_state: cancel_reason,
      Cancel_message_state: cancel_message,
    });
  }
  close_cancel_reason_display_Modal() {
    this.setState({
      cancel_reason_display_Modal: false,
      Cancel_reason_state: "",
      cancel_message: "",
    });
  }

  warningWithSendNotification() {
    // alert('hi');
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure you want send SMS/PN?"
          onConfirm={() => this.submitNotificationModal()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, Send it!"
          cancelBtnText="Cancel"
          showCancel
        >
          SMS / PN will be sent to the customer
        </SweetAlert>
      ),
    });
  }
  warningWithSendB2bNotification(p_orderid, b2bEmail, validityDate) {
    if (!validityDate || validityDate === "") {
      this.setState({
        validityDateError: (
          <div
            className="alert alert-danger"
            style={{
              padding: "6px 1px",
              position: "absolute",
              bottom: "70px",
              left: "54px",
              color: "#fb404b",
              textDecoration: "none",
              background: "#ffff",
              borderRadius: "3px",
              fontSize: "100%",
            }}
            role="alert"
          >
            Please select The Date
          </div>
        ),
      });
    } else {
      this.setState({
        alert: (
          <SweetAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Are you sure you want send B2B Quotation?"
            onConfirm={() =>
              this.sendB2bEmail(p_orderid, b2bEmail, validityDate)
            }
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText="Yes, Send it!"
            cancelBtnText="Cancel"
            showCancel
          >
            B2B Quotation will be email to the customer
          </SweetAlert>
        ),
      });
    }
  }

  warningWithConfirmAndChangeStatus() {
    // alert('hi');

    /// check rider blank or not
    let error = false;
    var rider_cour = null;
    var is_courier_partner = 0;
    if (this.state.currier_disabled == "yes") {
      is_courier_partner = 0;
      if (!this.state.rider_info || !this.state.rider_info.value) {
        error = true;
        this.setState({
          rider_infoError: (
            <small className="text-danger">Rider is required.</small>
          ),
        });
      } else {
        rider_cour = this.state.rider_info.value;

        this.setState({ rider_infoError: null });
      }
    } else {
      is_courier_partner = 1;
      if (this.state.currier_id == null) {
        error = true;
        this.setState({
          currier_idError: (
            <small className="text-danger">Currier is required.</small>
          ),
        });
      } else {
        this.setState({ currier_idError: null });
      }
    }
    if (!error) {
      this.setState({
        alert: (
          <SweetAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Are you sure?"
            onConfirm={() => this.submitriderdetailsModal()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText="Confirm"
            cancelBtnText="Cancel"
            showCancel
          >
            Please confirm that you have double checked the items added to the
            system against the items packed
          </SweetAlert>
        ),
      });
    }
  }
  warningWithConfirmAndCancelMessage(id) {
    // alert('hi');
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deleteorderdetails(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this Order Detail !
        </SweetAlert>
      ),
    });
  }
  downloadpre(url) {
    if (url != "") {
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.setAttribute("download", url);
      // document.body.appendChild(link)
      link.click();
    } else {
      this.setState({
        alert: (
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            <h3>No prescription uploaded!</h3>
          </SweetAlert>
        ),
      });
      // alert("No prescription uploaded")
    }
  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }
  downloadinvoice(id) {
    // const FileDownload = require('js-file-download');
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ pdfloading: true, processing: false }, () => {
      DownloadOrder(id, obj).then((res) => {
        this.setState({ pdfloading: false });
        var ddata = res.data.data.pdf_url;
        // const url = ddata;
        // axio
        // download(ddata.data,file.file_name,content)
        // FileDownload(ddata,'order_'+id+'.pdf')
        // const url = window.URL.createObjectURL(new Blob([res.data]))
        // console.log(url);
        const link = document.createElement("a");
        link.href = ddata;
        link.target = "_blank";
        link.setAttribute("download", "order_" + id + ".pdf");
        // document.body.appendChild(link)
        link.click();
        // this.setState({
        //   viewinvoice : ddata
        // })
        this.setState({ pdfloading: false, processing: true });
      });
    });
  }
  viewpdf(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ pdfloading: true }, () => {
      DownloadOrder(id, obj).then((res) => {
        this.setState({
          //    pdfloading: false,
        });
        var ddata = res.data.data.pdf_url;
        return <a href={ddata} target="_balnk"></a>;
      });
    });
  }
  deleteorderdetails(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    // alert(id);
    // this.setState({
    //       alert : null
    //     })
    DeleteOrder(id, obj)
      .then((res) => {
        this.setState({
          alert: null,
        });
        this.searchData();
      })
      .catch((error) => {
        this.handleNetworkError("bl");
      });
  }
  getdata(url) {
    this.setState({ page: url });
    this.searchData();
  }
  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });

    this.searchdata();
  };
  salesAgentOnChange = (event) => {
    this.setState({
      salesAgentValue: event.target.value,
    });

    this.searchdata();
  };

  onSelectnew = (datarange, states) => {
    console.log(datarange.start.format("YYYY-MM-DD"));
    console.log("d" + this.state.datarange.start);

    this.setState({
      datarange,
      states,
      isdatepickeron: !this.state.isdatepickeron,
      delivery_from_date: datarange.start.format("YYYY-MM-DD"),
      delivery_to_date: datarange.end.format("YYYY-MM-DD"),
    });
  };

  onChangeTrack = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  onChange2 = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });

    this.searchdatalate(value, this.state.is_courier_partner);
  };

  oncancelchnage = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    // const value = target.type === 'datetime' ? target.Datetime : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  };
  onnotificationchange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    // const value = target.type === 'datetime' ? target.Datetime : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  };
  onpaymentchange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    // const value = target.type === 'datetime' ? target.Datetime : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
    if (name == "paidamount") {
      var total_amunt = "";
      var paid_amount = "";
      var p_paid_amount = "";
      if (this.state.p_paid_amount == "" || this.state.p_paid_amount == null) {
        p_paid_amount = 0;
      } else {
        p_paid_amount = this.state.p_paid_amount;
      }
      total_amunt =
        parseFloat(this.state.p_total_cost) - parseFloat(p_paid_amount);
      // paid_amount =  parseFloat(value)
      var remain_amount = 0;
      if (value == "") {
        paid_amount = 0;
      } else {
        paid_amount = parseFloat(value);
      }
      remain_amount = parseFloat(total_amunt) - parseFloat(paid_amount);
      remain_amount = remain_amount.toFixed(2);
      this.setState({ remainpaymentamount: remain_amount });
    }
  };
  resetSearch() {
    sessionStorage.removeItem("orderSearchFilters");
    this.setState({
      salesAgentValue: "",
      subscriber: "",
      source: "",
      status: "",
      expectedDate: "",
      rider_id: "",
      orderdate: "",
      b2b: "",
      paymentoption: "",
      order_id_filter: "",
      po_number: "",
      channel_filter: "",
      order_type_filter: "",
      fromdate_filter: "",
      todate_filter: "",
      todateerror: null,
      value: "",
      courier_partner: "",
      is_courier_partner: 0,
      isdaterangepickerOpen: false,
      branch: "",
      orderSubType: "",
      partial_sent: "",
      resultCount: 0,
      is_claimable: 0,
      delivery_Type: "",
    });
    this.searchDatalate("", 0);
  }
  async editOrder(cus, channel, order_sub_type) {
    if (channel == "app") {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      console.log(cus, "<= id || obj =>", obj);
      var review = "1";
      await Updatereview(cus, review, obj).then((res) => {
        console.log(res, "update view order ");
      });
    }
    if (order_sub_type === 3) {
      this.props.history.push("/admin/edit-pickUp/" + cus);
    } else {
      this.props.history.push("/admin/order/" + cus);
    }
  }

  async editOrderNew(cus, channel, order_sub_type) {
    if (channel == "app") {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      console.log(cus, "<= id || obj =>", obj);
      var review = "1";
      await Updatereview(cus, review, obj).then((res) => {
        console.log(res, "update view order ");
      });
    }
    if (order_sub_type === 3) {
      this.props.history.push("/admin/edit-pickUp/" + cus);
    } else {
      this.props.history.push("/admin/order-new/" + cus);
    }
  }
  async cancellationOrder(id) {
    this.setState({
      cancelorderModal: true,
      selected_id: id ? [{ id: id }] : [],
      bulkSelect: id ? "5" : "",
      cancelModalTitle: "Cancel Bill",
      cancelModalLabel: "Cancel Bill Reason",
    });
  }

  async replicateOrder(cus, channel) {
    if (channel == "app") {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var review = "1";
      await Updatereview(cus, review, obj).then((res) => {
        console.log(res, "update view order ");
      });
    }
    this.props.history.push("/admin/replicate-order/" + cus);
  }
  openModal = () => {
    this.setState({ showModal: true });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  goToPickUp = () => {
    this.setState({ showModal: false }, () => {
      this.props.history.push("/admin/add-pickUp");
    });
  };

  goToOrder = () => {
    this.setState({ showModal: false }, () => {
      this.props.history.push("/admin/add-order-2");
    });
  };

  handleCompleteOrderOneClick(id) {
    const selectedOrder = this.state.order_chk.find(
      (data) => data.id === id,
    ).orderitem;
    const selectedOrderItesValidation = selectedOrder.filter((item) => {
      if (Number(item.quantity) > Number(item.medication.total_quantity)) {
        return item;
        // orderItems.push({medicineObject})
      }
    });
    if (selectedOrderItesValidation.length !== 0) {
      const validationData = selectedOrderItesValidation.map((data) => {
        return {
          orderId: data.id,
          medicine: data.medication.title,
          code: data.medication.item_code,
          actual_avail: data.medication.total_quantity,
          required: data.quantity,
        };
      });
      this.setState({
        medicationListing: validationData,
        showOutOfStock: true,
      });
    } else if (selectedOrder.length === 0) {
      this.setState({
        alert: (
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title="Please Add Some Medicine to this order!"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          />
        ),
      });
    } else {
      this.setState({
        alert: (
          <SweetAlert
            className="order_alert"
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.completeOrderOnOneClcik(id)}
            onCancel={() => this.hideAlert()}
            confirmBtnText="Yes"
            cancelBtnText="No"
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            showCancel
          >
            <h4>Are you sure you want to update this order as completed.</h4>
          </SweetAlert>
        ),
      });
    }
  }

  async completeOrderOnOneClcik(orderId) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    let order_id = [];
    const riderId = 467;
    const orderStatusPacked = "11";
    const orderStatusDispatched = "3";
    const isCourierPartner = 0;
    const trackingId = "";
    const trackingURL = "";
    const trackingNote = "";
    const paidAmount = "0";
    const paymentType = "1";
    order_id.push(orderId);
    this.setState({ isLoading: true, alert: null });
    await updateOrdersRider(
      order_id,
      riderId,
      orderStatusPacked,
      isCourierPartner,
      trackingId,
      trackingURL,
      trackingNote,
      obj,
    ).then((res) => res);
    await updateOrdersRider(
      order_id,
      riderId,
      orderStatusDispatched,
      isCourierPartner,
      trackingId,
      trackingURL,
      trackingNote,
      obj,
    ).then((res) => res);

    await updatepaymentinfo(paymentType, paidAmount, orderId, obj).then(
      (res) => {
        if (res.data.success === true) {
          this.setState({ processing: true });
          this.componentDidMount();
          setTimeout(() => {
            this.setState({ isLoading: false });
          }, 3000);
        }
      },
    );
  }

  async handleUpdateStatus(e) {
    this.setState({ isDisableChangeStatusButton: true });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    let sts_arr = [];
    let medicationList = [];
    var isOut = false;
    let isNotEligible = false;
    const insureMeAfterPackedRestrictedStatus = [1, 2, 6, 7, 9, 10, 12, 13, 14];

    if (this.state.bulkSelect != "" && this.state.bulkSelect != null) {
      const checkedOrder = (this.state.order_chk || []).filter(
        (item) => item.isChecked,
      );

      await Promise.all(
        checkedOrder.map(async (item) => {
          this.state.selected_id.push({ id: item.id });
          sts_arr.push({ id: item.id, status: this.state.bulkSelect });
          // console.log("item.id", item.id);
          if (
            !!item.is_insureme &&
            (item.order_status === 11 ||
              item.order_status === 3 ||
              item.order_status === 8)
          ) {
            const isEligibleStatus = insureMeAfterPackedRestrictedStatus.some(
              (rest) => rest == this.state.bulkSelect,
            );

            if (!!isEligibleStatus) {
              isNotEligible = isEligibleStatus;
            }
          }
          if (item.order_sub_type == 2) {
            // if B2B order
            if (
              // this.state.bulkSelect == 1 ||
              this.state.bulkSelect == 2 || //Processing
              this.state.bulkSelect == 3 || //Dispatched
              this.state.bulkSelect == 4 || // Completed
              // this.state.bulkSelect == 8 ||
              this.state.bulkSelect == 11 || // Packed
              this.state.bulkSelect == 12 || // Ready
              this.state.bulkSelect == 17 // Procument Ready
              // ||
              // this.state.bulkSelect == 14
            ) {
              console.log("bulk select", this.state.bulkSelect);
              let medicine = item.orderitem;
              await Promise.all(
                medicine.map(async (data) => {
                  let partialSentQuantity = 0; // Global Variable to deduct partial sent quantity
                  let removeAllocatedQuantity = 0; // Global Variable to deduct current order allocated quantity
                  // await allocationValuePopUp(data.medication_id, obj)
                  //   .then((res) => {
                  //     const AllocationData = res.data;
                  //     const ReducePartialOrderQuantity = AllocationData.filter(
                  //       (item) => {
                  //         if (item.partial_sent) {
                  //           partialSentQuantity =
                  //             partialSentQuantity + item.quantity;
                  //         }
                  //       }
                  //     );
                  //     if (
                  //       this.state.bulkSelect == 3 ||   // Dispatched
                  //       this.state.bulkSelect == 11 || // Packed
                  //       this.state.bulkSelect == 12 || // Ready
                  //       this.state.bulkSelect == 2    // Processing
                  //     ) {
                  //       const RemoveAllocationQuantity = AllocationData.find(
                  //         (www) =>
                  //           www.order_id === Number(item.id) &&
                  //           www.id === Number(data.id)
                  //       );
                  //       removeAllocatedQuantity =
                  //         RemoveAllocationQuantity.quantity;
                  //     }
                  //   })
                  //   .catch((error) => {
                  //     console.error("Error fetching allocated data:", error);
                  //   });

                  if (data.medication) {
                    let actualTotalQuantity = Number(
                      data.medication.total_quantity || 0,
                    );
                    // let totalAllocatedQuantity =
                    //   Number(data.medication.total_allocated || 0) -
                    //   Number(partialSentQuantity || 0) -
                    //   Number(removeAllocatedQuantity || 0);

                    const remainingOrderableQuantity = actualTotalQuantity; //- totalAllocatedQuantity;

                    const isStockNotUpated = data.stock_updated === false;
                    const isMedicinePartialSent = !data.partial_sent;
                    let isProcumentReady = false;
                    if (this.state.bulkSelect == 17) {
                      isProcumentReady = true;
                    }

                    if (
                      (this.state.store === 1 || this.state.store === null) &&
                      isStockNotUpated &&
                      remainingOrderableQuantity < Number(data.quantity || 0) &&
                      (isMedicinePartialSent || isProcumentReady)
                    ) {
                      let actualAvailableQuantity = Number(
                        data.medication.total_quantity,
                      );
                      //-
                      //Number(data.medication.total_allocated);
                      var details = {
                        orderId: item.id,
                        medicine: data.medication.title,
                        code: data.medication.item_code,
                        actual_avail:
                          actualAvailableQuantity > 0
                            ? actualAvailableQuantity
                            : 0,
                        required: data.quantity,
                      };
                      medicationList.push(details);
                      isOut = true;
                    }
                  }
                }),
              );
            }
          } else if (item.order_sub_type == 1) {
            if (
              // this.state.bulkSelect == 12 ||
              this.state.bulkSelect == 11 ||
              this.state.bulkSelect == 3 ||
              this.state.bulkSelect == 4 ||
              this.state.bulkSelect == 2 ||
              this.state.bulkSelect == 17

              // this.state.bulkSelect == 8
              // ||
              // this.state.bulkSelect == 14
            ) {
              let medicine = item.orderitem;

              // for (let i = 0; i < medicine.length; i++) {
              await Promise.all(
                medicine.map(async (data) => {
                  let partialSentQuantity = 0;
                  let removeAllocatedQuantity = 0;
                  // await allocationValuePopUp(data.medication_id, obj)
                  //   .then((res) => {
                  //     const AllocationData = res.data;
                  //     const ReducePartialOrderQuantity = AllocationData.filter(
                  //       (item) => {
                  //         if (item.partial_sent) {
                  //           partialSentQuantity =
                  //             partialSentQuantity + item.quantity;
                  //         }
                  //       }
                  //     );
                  //     if (
                  //       this.state.bulkSelect == 3 ||
                  //       this.state.bulkSelect == 11 ||
                  //       this.state.bulkSelect == 12 ||
                  //       this.state.bulkSelect == 2
                  //     ) {
                  //       const RemoveAllocationQuantity = AllocationData.find(
                  //         (www) =>
                  //           www.order_id === Number(item.id) &&
                  //           www.id === Number(data.id)
                  //       );
                  //       removeAllocatedQuantity =
                  //         RemoveAllocationQuantity.quantity;
                  //     }
                  //   })
                  //   .catch((error) => {
                  //     console.error("Error fetching allocated data:", error);
                  //   });
                  if (data.medication) {
                    let actualTotalQuantity = Number(
                      data.medication.total_quantity || 0,
                    );
                    // let totalAllocatedQuantity =
                    //   Number(data.medication.total_allocated || 0) -
                    //   Number(partialSentQuantity || 0) -
                    //   Number(removeAllocatedQuantity || 0);
                    const remainingOrderableQuantity = actualTotalQuantity; //- totalAllocatedQuantity;
                    const isStockNotUpated = data.stock_updated === false;
                    const isMedicinePartialSent = !data.partial_sent;

                    if (
                      (this.state.store === 1 || this.state.store === null) &&
                      isStockNotUpated &&
                      remainingOrderableQuantity < Number(data.quantity || 0) &&
                      isMedicinePartialSent
                    ) {
                      let actualAvailableQuantity = Number(
                        data.medication.total_quantity,
                      ); //-
                      // Number(data.medication.total_allocated);
                      var details = {
                        orderId: item.id,
                        medicine: data.medication.title,
                        code: data.medication.item_code,
                        actual_avail:
                          actualAvailableQuantity > 0
                            ? actualAvailableQuantity
                            : 0,
                        required: data.quantity,
                      };
                      medicationList.push(details);
                      isOut = true;
                    }

                    if (data.stock_updated === true) {
                      return;
                    }
                  }
                  return details;
                }),
              );
            }
          }
        }),
      );
      if (isOut) {
        this.setState({
          showOutOfStock: true,
          medicationListing: medicationList,
        });
      }

      if (!isOut && !isNotEligible) {
        if (this.state.bulkSelect == "5") {
          if (this.state.selected_id.length > 0) {
            this.setState({
              cancelorderModal: true,
              cancelModalTitle: "Cancel Order",
              cancelModalLabel: "Cancel Order Reason",
            }); // faaaahhhhhhhh
          } else {
            this.setState({
              alert: (
                <SweetAlert
                  style={{ display: "block", marginTop: "-100px" }}
                  title="Please select order!"
                  onConfirm={() => this.hideAlert()}
                  onCancel={() => this.hideAlert()}
                  confirmBtnBsStyle="info"
                />
              ),
            });
          }
        }
        if (this.state.bulkSelect == "14") {
          if (this.state.selected_id.length > 0) {
            this.setState({ supplierModal: true });
          } else {
            this.setState({
              alert: (
                <SweetAlert
                  style={{ display: "block", marginTop: "-100px" }}
                  title="Please select order!"
                  onConfirm={() => this.hideAlert()}
                  onCancel={() => this.hideAlert()}
                  confirmBtnBsStyle="info"
                />
              ),
            });
          }
        }

        if (this.state.bulkSelect == "11" || this.state.bulkSelect == "3") {
          if (this.state.selected_id.length > 0) {
            let order_id = [];
            var htmlContent = "";
            var order_info = [];
            var cus_arr = [];
            var chk_arr = [];
            this.setState({ btn_text: "Submit" });
            this.setState({ btn_disabled: true });

            this.state.selected_id.map(async (item) => {
              if (item.id != "") {
                let role = 5;
                getallrider(this.state.district, role, obj).then((res) => {
                  const data = res.data;
                  let riderItems = [];
                  data.map((item) => {
                    if (item.country_code === token.country_code) {
                      riderItems.push({
                        value: item.id,
                        label: item.name,
                      });
                    }
                    return item;
                  });
                  let defaultRider = null;
                  if (this.state.store !== 1 && this.state.store !== null) {
                    defaultRider =
                      riderItems.find((r) => r.label === "Self Pickup") || null;
                  }
                  this.setState({
                    rider_data: riderItems,
                    rider_details: data,
                    rider_info: defaultRider
                      ? defaultRider
                      : this.state.rider_info,
                  });
                });
                await getOrderById(item.id, obj).then((res) => {
                  const data = res.data;
                  cus_arr[data.id] = false;
                  chk_arr[data.id] = false;
                  const partialSentFalse = data.orderItems.filter(
                    (item) => !item.partial_sent,
                  );
                  order_info.push({
                    id: data.id,
                    //lead: data.lead.name,
                    //lead_phno: data.lead.mobile,
                    prescriptions: data.prescriptions,
                    prescription_text: data.prescription_text,
                    prescription_note: data.prescription_note,
                    orderItems: partialSentFalse,
                  });
                  this.setState({
                    order_info: order_info,
                    rider_info: data.rider_id
                      ? { value: data.rider_id, label: data.rider_name }
                      : this.state.rider_info,
                    tracking_id: data.tracking_id,
                    tracking_url: data.tracking_url,
                    tracking_note: data.tracking_note,
                    is_currier: data.is_courier_partner === 1 ? true : false,
                    currier_id:
                      data.is_courier_partner === 1
                        ? {
                            label: data.rider_name,
                            value: data.rider_id,
                          }
                        : null,
                  });
                });
              }
            });
            if (
              this.state.bulkSelect == "11" &&
              this.state.selectedOrderData &&
              this.state.selectedOrderData.is_insureme
            ) {
              this.setState({ isLoading: true });
              let insuremeClaimableAmount = Number(
                this.state.selectedOrderData.basket_value,
              );
              await submitInsuremeClaimRequest(
                this.state.selectedOrderData.id,
                insuremeClaimableAmount,
                this.state.selectedOrderData.lead_id,
                obj,
              ).then((res) => {
                if (res.data.status === 200) {
                  this.setState({
                    insuremeBannerText: (
                      <div
                        style={{
                          backgroundColor: "#E0FBE2 ",
                          // position: "absolute",
                          width: "100%",
                          flex: 1,
                          left: "300px",
                          padding: "10px",
                          zIndex: 1000,
                          borderRadius: "5px",
                        }}
                      >
                        <span
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            flex: 1,
                            gap: "20px",
                          }}
                        >
                          <i
                            class="fa fa-check-circle-o"
                            style={{ fontSize: "36px", color: "green" }}
                          ></i>
                          <p style={{ color: "green", marginTop: "7px" }}>
                            Insureme Claim Verification Success.
                          </p>
                        </span>
                      </div>
                    ),
                  });
                  // this.setState({ viewMedDetails: false });
                  this.setState({ is_checked: chk_arr });
                  this.setState({ ridermodel: true });
                } else {
                  this.setState({
                    alert: (
                      <SweetAlert
                        lassName="order_alert"
                        style={{ display: "block", marginTop: "-100px" }}
                        error
                        title={res.data.error.message}
                        onConfirm={() => this.hideAlert()}
                        onCancel={() => this.hideAlert()}
                      >
                        <h4>&nbsp;</h4>
                      </SweetAlert>
                    ),
                    insuremeBannerText: (
                      <div
                        style={{
                          backgroundColor: "#FFBBBF ",
                          // position: "absolute",
                          width: "100%",
                          flex: 1,
                          left: "300px",
                          padding: "10px",
                          zIndex: 1000,
                          borderRadius: "5px",
                        }}
                      >
                        <span
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            flex: 1,
                            gap: "20px",
                          }}
                        >
                          <i
                            class="	fa fa-close"
                            style={{ fontSize: "36px", color: "red" }}
                          ></i>
                          <p style={{ color: "red", marginTop: "7px" }}>
                            {res.data.error.message}
                          </p>
                        </span>
                      </div>
                    ),
                  });
                }
                console.log("res", res.data.status);
              });
              this.setState({ isLoading: false }, () => {});
              // this.setState({ processing: false });
              // console.log("insuremeClaimableAmount", insuremeClaimableAmount);
            } else {
              /** get order details */
              this.setState({
                order_info: [],
                insuremeBannerText: null,
              });
              // this.setState({ viewMedDetails: false });
              this.setState({ is_checked: chk_arr });
              this.setState({ ridermodel: true });
            }
          } else {
            this.setState({
              alert: (
                <SweetAlert
                  style={{ display: "block", marginTop: "-100px" }}
                  title="Please select order!"
                  onConfirm={() => this.hideAlert()}
                  onCancel={() => this.hideAlert()}
                  confirmBtnBsStyle="info"
                />
              ),
            });
          }
        }
        if (
          this.state.bulkSelect != "5" &&
          this.state.bulkSelect != "11" &&
          this.state.bulkSelect != "14" &&
          this.state.bulkSelect != "3"
        ) {
          if (sts_arr.length > 0) {
            this.setState({ isLoading: true });
            updateOrderStatus(
              sts_arr,
              this.state.ordercancelreason,
              this.state.cancel_message,
              // this.state.expectedDate,
              obj,
            )
              .then(() => {
                setTimeout(() => {
                  this.searchData();
                  this.setState({ selected_id: [], isLoading: false });
                }, 3000);
              })
              .catch(() => {
                setTimeout(() => {
                  this.searchData();
                }, 3000);
              });
          } else {
            this.setState({
              alert: (
                <SweetAlert
                  style={{ display: "block", marginTop: "-100px" }}
                  title="Please select order!"
                  onConfirm={() => this.hideAlert()}
                  onCancel={() => this.hideAlert()}
                  confirmBtnBsStyle="info"
                />
              ),
            });
          }
        }
      } else {
        if (isNotEligible) {
          this.setState({
            alert: (
              <SweetAlert
                style={{ display: "block", marginTop: "-100px" }}
                title="You can only change the status to 'Dispatched' or 'Payment Pending"
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="info"
              />
            ),
          });
        }
        // } else {
        //   this.setState({
        //     alert: (
        //       <SweetAlert
        //         style={{ display: "block", marginTop: "-100px" }}
        //         title="Please select status!"
        //         onConfirm={() => this.hideAlert()}
        //         onCancel={() => this.hideAlert()}
        //         confirmBtnBsStyle="info"
        //       />
        //     ),
        //   });
        // }
      }
    }
    this.setState({ isDisableChangeStatusButton: false });
  }

  searchdata(e) {
    this.setState({ page: "", isdaterangepickerOpen: false });
    this.searchData();
  }

  searchdatalate(value, isCurrier) {
    this.setState({ page: "", isdaterangepickerOpen: false });
    this.searchDatalate(value, isCurrier);
  }

  searchData(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var date = "";
    var today = "";
    date = new Date(this.state.orderdate);
    var dd = ("0" + date.getDate()).slice(-2);
    var mm = ("0" + (date.getMonth() + 1)).slice(-2);
    var yyyy = date.getFullYear();
    if (dd != "aN") {
      today = yyyy + "-" + mm + "-" + dd;
    } else {
      today = "";
    }

    var fromdate = "";
    var finalfromdate = "";

    fromdate = new Date(this.state.value.start);
    var fdd = ("0" + fromdate.getDate()).slice(-2);
    var fmm = ("0" + (fromdate.getMonth() + 1)).slice(-2);
    var fyyyy = fromdate.getFullYear();
    if (fdd != "aN") {
      finalfromdate = fyyyy + "-" + fmm + "-" + fdd;
    } else {
      finalfromdate = "";
    }

    var todate = "";
    var todatefinal = "";
    todate = new Date(this.state.value.end);
    var tdd = ("0" + todate.getDate()).slice(-2);
    var tmm = ("0" + (todate.getMonth() + 1)).slice(-2);
    var tyyyy = todate.getFullYear();
    if (tdd != "aN") {
      todatefinal = tyyyy + "-" + tmm + "-" + tdd;
    } else {
      todatefinal = "";
    }

    if (finalfromdate.length != 0) {
      if (todatefinal.length == 0) {
        this.setState({
          todateerror: (
            <small className="text-danger">Todate is required.</small>
          ),
        });
        return;
      } else {
        this.setState({ todateerror: null });
      }
    }

    var riderid = "";
    var is_courier_partner = "";
    if (this.state.is_courier_partner == true) {
      is_courier_partner = 1;
      riderid = this.state.courier_partner;
    } else if (this.state.partial_sent === true) {
      is_courier_partner = "";
    } else {
      is_courier_partner = 0;
      riderid = this.state.rider_id;
    }

    const partial_sent = this.state.partial_sent ? this.state.partial_sent : "";

    this.setState({ noRecordFound: false });
    this.setState({ loading: true }, () => {
      searchOrders(
        this.state.subscriber,
        this.state.status,
        riderid,
        this.state.source,
        today,
        this.state.paymentoption,
        this.state.b2b ? this.state.b2b.label : "",
        this.state.channel_filter,
        this.state.order_id_filter,
        this.state.po_number,
        finalfromdate,
        todatefinal,
        this.state.page,
        this.state.city_id,
        this.state.order_type_filter,
        is_courier_partner,
        this.state.orderSubType.value ? this.state.orderSubType.value : "",
        obj,
        this.state.salesAgentValue
          ? this.state.salesAgentValue
          : this.state.salesAgentValue,
        // this.state.branch ? this.state.branch.value : "",
        partial_sent,
        this.state.is_claimable,
        this.state.StoreManager === 1 && this.state.store === null
          ? 0
          : this.state.store,
        this.state.branch ? this.state.branch.value : "",
        this.state.delivery_Type,
      )
        .then((response) => {
          var data = response.data;
          const count = data.total;
          this.setState({
            resultCount: count,
            order_details: data,
            loading: false,
          });
          if (count === 0) {
            this.setState({ noRecordFound: true });
          }
          if (data.data.length == 0) {
            this.setState({ noRecordFound: true });
          }
          var $no_pages = [];
          let serach_url = "";
          let order_chk = [];
          let serach_string = "";
          for (var i = 1; i <= data.last_page; i++) {
            if (serach_string == "") {
              $no_pages.push(i);
            } else {
              $no_pages.push(i);
            }
          }
          if (data.current_page == data.last_page) {
            this.setState({ prevdisabled: null });
            this.setState({ nextdisabled: "1" });
          } else if (data.current_page == 1) {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: "1" });
          } else {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: null });
          }
          if (data.last_page == 1) {
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          if (data.data.length == 0) {
            $no_pages = [];
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          this.setState({ currentPage: data.current_page });
          if (data.next_page_url != null) {
            if (serach_string == "") {
              this.setState({
                nextpage: data.next_page_url.substring(
                  data.next_page_url.indexOf("=") + 1,
                ),
              });
            } else {
              this.setState({
                nextpage: data.next_page_url.substring(
                  data.next_page_url.indexOf("=") + 1,
                ),
              });
            }
          } else {
            this.setState({ nextpage: "#" });
          }
          if (data.prev_page_url != null) {
            if (serach_string == "") {
              this.setState({
                prevpage: data.prev_page_url.substring(
                  data.prev_page_url.indexOf("=") + 1,
                ),
              });
            } else {
              this.setState({
                prevpage: data.prev_page_url.substring(
                  data.prev_page_url.indexOf("=") + 1,
                ),
              });
            }
          } else {
            this.setState({ prevpage: "#" });
          }
          this.setState({ paginationData: $no_pages });
          response.data.data.map((ele) => {
            ele["isChecked"] = false;
            ele["isDisabled"] = false;
            order_chk.push(ele);
          });
          this.setState({
            order_details: response.data,
            loading: false,
          });
          this.setState({
            order_chk: order_chk,
          });
          this.setState({ isLoading: false });
        })
        .catch((error) => {
          this.handleNetworkError("bl");
          this.setState({ isLoading: false });
        });

      get_express_pending_order(obj).then((res) => {
        const data = res.data;
        console.log(data, "express data");
        this.setState({
          express_data: data,
        });
      });
      get_normal_pending_order(obj).then((res) => {
        const data = res.data;
        console.log(data, "normal data");
        this.setState({
          normal_data: data,
        });
      });
    });
    sessionStorage.setItem(
      "orderSearchFilters",
      JSON.stringify({
        subscriber: this.state.subscriber,
        status: this.state.status,
        orderSubType: this.state.orderSubType,
      }),
    );
  }

  searchDatalate(value, isCurrier) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var date = "";
    var today = "";
    date = new Date(this.state.orderdate);
    var dd = ("0" + date.getDate()).slice(-2);
    var mm = ("0" + (date.getMonth() + 1)).slice(-2);
    var yyyy = date.getFullYear();
    if (dd != "aN") {
      today = yyyy + "-" + mm + "-" + dd;
    } else {
      today = "";
    }

    var fromdate = "";
    var finalfromdate = "";

    fromdate = new Date(this.state.value.start);
    var fdd = ("0" + fromdate.getDate()).slice(-2);
    var fmm = ("0" + (fromdate.getMonth() + 1)).slice(-2);
    var fyyyy = fromdate.getFullYear();
    if (fdd != "aN") {
      finalfromdate = fyyyy + "-" + fmm + "-" + fdd;
    } else {
      finalfromdate = "";
    }

    var todate = "";
    var todatefinal = "";
    todate = new Date(this.state.value.end);
    var tdd = ("0" + todate.getDate()).slice(-2);
    var tmm = ("0" + (todate.getMonth() + 1)).slice(-2);
    var tyyyy = todate.getFullYear();
    if (tdd != "aN") {
      todatefinal = tyyyy + "-" + tmm + "-" + tdd;
    } else {
      todatefinal = "";
    }

    if (finalfromdate.length != 0) {
      if (todatefinal.length == 0) {
        this.setState({
          todateerror: (
            <small className="text-danger">Todate is required.</small>
          ),
        });
        return;
      } else {
        this.setState({ todateerror: null });
      }
    }

    var is_courier_partner = "";
    if (isCurrier == true) {
      is_courier_partner = 1;
    } else {
      is_courier_partner = 0;
    }

    this.setState({ noRecordFound: false });
    this.setState({ loading: true }, () => {
      searchOrders(
        this.state.subscriber,
        this.state.status,
        value,
        this.state.source,
        today,
        this.state.paymentoption,
        this.state.b2b,
        this.state.channel_filter,
        this.state.order_id_filter,
        this.state.po_number,
        finalfromdate,
        todatefinal,
        this.state.page,
        this.state.city_id,
        this.state.order_type_filter,
        is_courier_partner,
        this.state.orderSubType.value ? this.state.orderSubType.value : "",
        obj,
        this.state.salesAgentValue,
        this.state.branch.value == undefined ? "" : this.state.branch.value,
        this.state.partial_sent,
        this.state.is_claimable,
        this.state.StoreManager === 1 && this.state.store === null
          ? 0
          : this.state.store,
        this.state.branch,
      )
        .then((response) => {
          var data = response.data;
          if (data.data.length == 0) {
            this.setState({ noRecordFound: true });
          }
          var $no_pages = [];
          let serach_url = "";
          let order_chk = [];
          let serach_string = "";
          for (var i = 1; i <= data.last_page; i++) {
            if (serach_string == "") {
              $no_pages.push(i);
            } else {
              $no_pages.push(i);
            }
          }
          if (data.current_page == data.last_page) {
            this.setState({ prevdisabled: null });
            this.setState({ nextdisabled: "1" });
          } else if (data.current_page == 1) {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: "1" });
          } else {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: null });
          }
          if (data.last_page == 1) {
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          if (data.data.length == 0) {
            $no_pages = [];
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          this.setState({ currentPage: data.current_page });
          if (data.next_page_url != null) {
            if (serach_string == "") {
              this.setState({
                nextpage: data.next_page_url.substring(
                  data.next_page_url.indexOf("=") + 1,
                ),
              });
            } else {
              this.setState({
                nextpage: data.next_page_url.substring(
                  data.next_page_url.indexOf("=") + 1,
                ),
              });
            }
          } else {
            this.setState({ nextpage: "#" });
          }
          if (data.prev_page_url != null) {
            if (serach_string == "") {
              this.setState({
                prevpage: data.prev_page_url.substring(
                  data.prev_page_url.indexOf("=") + 1,
                ),
              });
            } else {
              this.setState({
                prevpage: data.prev_page_url.substring(
                  data.prev_page_url.indexOf("=") + 1,
                ),
              });
            }
          } else {
            this.setState({ prevpage: "#" });
          }
          this.setState({ paginationData: $no_pages });
          response.data.data.map((ele) => {
            ele["isChecked"] = false;
            order_chk.push(ele);
          });
          this.setState({
            order_details: response.data,
            loading: false,
          });
          this.setState({
            order_chk: order_chk,
          });
          this.setState({ isLoading: false });
        })
        .catch((error) => {
          this.handleNetworkError("bl");
          this.setState({ isLoading: false });
        });

      get_express_pending_order(obj).then((res) => {
        const data = res.data;
        console.log(data, "express data");
        this.setState({
          express_data: data,
        });
      });
      get_normal_pending_order(obj).then((res) => {
        const data = res.data;
        console.log(data, "normal data");
        this.setState({
          normal_data: data,
        });
      });
    });
  }
  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }
  async componentDidMount() {
    const savedFilters = sessionStorage.getItem("orderSearchFilters");

    this.setState({ _notificationSystem: this.refs.notificationSystem });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({
      userData: token,
      StoreManager: token.role,
      store: token.store_id,
    });

    await Get_Settings(obj).then((res) => {
      const isMultiplePharmchy = res.data.data.find((data) => data.id === 11);
      this.setState({ settingsData: isMultiplePharmchy });
    });

    if (savedFilters) {
      const filters = JSON.parse(savedFilters);

      this.setState(
        {
          ...filters,
          loading: true,
        },
        () => {
          this.searchData();
        },
      );
    } else {
      this.searchData();
    }

    this.searchData();

    getBrachDetailsCountryCodeWise(token.country_code, obj).then((res) => {
      const branchListOptions = res.data.map((data) => {
        return {
          value: data.id,
          label: data.name,
        };
      });
      this.setState({ branchList: branchListOptions });
    });

    this.interval = setInterval(() => this.searchData(), 240000);

    this.setState({
      useraccess: token.role,
    });

    getOrganizationDataWithoutPagination(obj).then((res) => {
      const companyData = res.data;
      const organizationDetail = companyData.map((data) => {
        return {
          value: data.id,
          label: data.company_name,
        };
      });
      this.setState({ b2bDetails: organizationDetail });
    });

    // getb2b(obj).then((res) => {
    //   this.setState({ b2bDetails: res.data.data });
    // });
    let role = 5;
    getallrider("", role, obj).then((res) => {
      const data = res.data.filter((rider) => rider.is_active === 1);
      this.setState({ allRiderData: data });
    });
    getallCurrier(10, obj).then((res) => {
      const data = res.data;
      var array1 = this.state.currier_details;
      var array2 = array1.concat(data);

      this.setState({
        currier_details: array2,
      });

      let currierItems = [];
      this.state.currier_details.map((x, i) => {
        currierItems.push({ value: x.id, label: x.name });
      });
      this.setState({
        currier_data: currierItems,
      });
    });
    getCity(obj, 1).then((res) => {
      this.setState({ city_info: res.data });
    });
    get_express_pending_order(obj).then((res) => {
      const data = res.data;
      console.log(data, "express data");
      this.setState({
        express_data: data,
      });
    });
    get_normal_pending_order(obj).then((res) => {
      const data = res.data;
      console.log(data, "normal data");
      this.setState({
        normal_data: data,
      });
    });
    getSalesRepresentative(obj).then((res) => {
      const data = res.data.data;
      let repItems = [];
      data.map((x, i) => {
        repItems.push({ value: x.id, label: x.name });
      });
      this.setState({
        salesAgentOptions: repItems,
      });
    });

    this.handlrTimeZone();
  }
  sendNotification(id, total_cost, paid_amount, order_status) {
    this.setState({
      p_orderid: id,
      shownotificationmodal: true,
      status: order_status,
    });
  }

  sendB2bEmail(order_id, b2bEmail, validityDate) {
    this.setState({
      processing: true,
      isLoading: true,
    });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    SendB2bEmailNotification(order_id, b2bEmail, validityDate, obj)
      .then((res) => {
        const data = res.data;
        this.setState({
          shownotificationmodal: false,
        });
        this.hideAlert();

        this.setState({
          showSmsMessageModal: true,
          smsMessage: res.data.message,
          processing: false,
          isLoading: false,
          b2bEmail: [],
          notificationtype: "delay",
          validityDate: "",
          validityDateError: null,
        });

        this.searchData();
      })
      .catch((error) => {
        this.handleNetworkError("bl");
      });
  }

  paymentdetail(id, total_cost, paid_amount, order_status, status_label) {
    if (
      order_status == 2 ||
      order_status == 11 ||
      order_status == 13 ||
      order_status == 14 ||
      order_status == 9
    ) {
      this.setState({
        alert: (
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title=""
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            <h4>
              Cant change the {status_label} to complete please change the
              status dispatched and complete the order
            </h4>
          </SweetAlert>
        ),
      });
    } else {
      this.setState({
        p_total_cost: "",
        remainpaymentamount: "0",
        paymenttype: "",
        paidamount: "0",
      });
      var p_check_a = "";
      if (paid_amount == null) {
        p_check_a = 0;
      } else {
        p_check_a = paid_amount;
      }
      var r_amount = parseFloat(total_cost) - parseFloat(p_check_a);
      r_amount = r_amount.toFixed(2);
      // total_cost = total_cost.toFixed(2);
      this.setState({
        showpaymentdetailmodal: true,
        p_orderid: id,
        p_total_cost: total_cost,
        p_paid_amount: paid_amount,
        remainpaymentamount: r_amount,
      });
    }
  }
  closepaymentdetailmodal() {
    this.setState({ showpaymentdetailmodal: false, errormessages: [] });
  }
  closeNotificationmodal() {
    this.setState({
      shownotificationmodal: false,
      errormessages: [],
      b2bEmail: [],
      notificationtype: "delay",
      validityDate: "",
      validityDateError: null,
    });
  }
  submitpaymentdetail() {
    this.setState({ errormessages: [] });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var total_amunt = "";
    var paid_amount = "";
    if (this.state.paymenttype == "2") {
      total_amunt = this.state.p_total_cost;
      paid_amount = parseFloat(this.state.paidamount);
      paid_amount = paid_amount.toFixed(2);
    } else if (this.state.paymenttype == "1") {
      paid_amount = "0";
    }
    updatepaymentinfo(
      this.state.paymenttype,
      paid_amount,
      this.state.p_orderid,
      obj,
    )
      .then((res) => {
        if (res.data.success == true) {
          this.setState({ loading: true });
          this.setState({ showpaymentdetailmodal: false });
          this.componentDidMount();
        } else if (res.data.success == false) {
          if (res.data.data.length != 0) {
            var ermessage = [];
            for (var key of Object.keys(res.data.data)) {
              var data = res.data.data[key];
              ermessage.push(data);
            }
            this.setState({ errormessages: ermessage });
            this.setState({ showpaymentdetailmodal: true });
          } else {
            this.handleClick("bl");
          }
        }
      })
      .catch((res) => {
        console.log(res);
      });
    //   updatepaymentinfo(this.state.paymenttype,paid_amount,this.state.p_orderid,obj)
    //   .then(res => {
    //     console.log(res)
    //     if(res.data.success == true)
    //     {
    //     this.setState({ loading: true });
    //     this.componentDidMount();
    //     }
    //   })
    //   .catch(res => {
    //     console.log(res);
    //   })
    // }
    // this.setState({ showpaymentdetailmodal: false });
  }
  addorder() {
    this.props.history.push("/admin/add-order");
  }

  addOrderNew() {
    this.props.history.push("/admin/add-order-2");
  }
  onParentOrganizationChange = (value) => {
    this.setState({
      b2b: value,
    });
    this.searchdata();
  };
  handleAllChecked = (event) => {
    let orders_st = this.state.order_chk;
    orders_st.forEach((st) => (st.isChecked = event.target.checked));
    this.setState({ order_chk: orders_st });
  };
  handleCheckChieldElement = (event) => {
    let checked = event.target.checked;
    let orders_st = this.state.order_chk;
    let selectedValue = orders_st.find((item) => item.id == event.target.value);
    if (this.state.settingsData.setting_value == "true") {
      if (!checked) {
        const filteredArray = this.state.checkedElement.filter(
          (item) => item.id != event.target.value,
        );
        this.setState({
          checkedElement: filteredArray,
        });
        if (filteredArray.length == 0) {
          const array = orders_st.map((item) => {
            item.isDisabled = false;
          });
        }
        this.setState({ district: "" });
      } else {
        if (!this.state.checkedElement.length) {
          this.setState({
            checkedElement: [selectedValue],
          });
          this.setState({ district: selectedValue.district });
        }
        const array = orders_st.map((item) => {
          if (item.district !== selectedValue.district) {
            item.isDisabled = true;
          }
        });
        this.setState({
          order_chk: array,
        });
      }
    }
    orders_st.forEach((st) => {
      if (st.id == event.target.value) {
        st.isChecked = event.target.checked;
      }
    });
    if (checked) {
      this.setState({ selectedOrderData: selectedValue });
    } else {
      this.setState({ selectedOrderData: null });
    }
    this.setState({ order_chk: orders_st });
  };
  onStatusChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    // const value = target.type === 'datetime' ? target.Datetime : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  };

  submitCancelOrderModal() {
    let error = false;
    if (this.state.ordercancelreason.trim() == "") {
      error = true;
      this.setState({
        ordercancelreasonError: (
          <small className="text-danger">Reason is required.</small>
        ),
      });
    } else {
      this.setState({ ordercancelreasonError: null });
    }
    if (!error) {
      this.setState({ isLoading: true });
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      let cancel_arr = [];
      let status_chnage = [];
      this.state.selected_id.map((item) => {
        if (item.id != "") {
          status_chnage.push({ id: item.id, status: this.state.bulkSelect });
          // cancel_arr.push({id:item.id ,cancelreason:this.state.ordercancelreason})
        }
      });
      updateOrderStatus(
        status_chnage,
        this.state.ordercancelreason,
        this.state.cancel_message,
        obj,
      )
        .then(() => {
          this.searchData();
        })
        .catch(() => {
          this.searchData();
        });
      this.setState({
        selected_id: [],
        bulkSelect: "",
        ordercancelreason: "",
        cancel_message: "",
        ordercancelreasonError: null,
        cancelorderModal: false,
        supplierModal: false,
      });
    }
  }
  submitSupplierModal() {
    let error = false;

    if (!error) {
      this.setState({
        isLoading: true,
        isdaterangepickerOpen: false,
        isdatepickeron: false,
      });
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      console.log(obj);
      let cancel_arr = [];
      // let status_chnage = [];
      // console.log(this.state.expectedDate);
      const status_chnage = this.state.selected_id.map((item) => {
        if (item.id != "") {
          if (!this.state.delivery_from_date) {
            const current = new Date();
            const end = new Date();
            const strtdate = `${current.getFullYear()}-${
              current.getMonth() + 1
            }-${current.getDate()}`;
            const enddate = `${end.getFullYear()}-${end.getMonth() + 1}-${
              end.getDate() + 7
            }`;
            this.setState({
              delivery_from_date: strtdate,
              delivery_to_date: enddate,
            });
            return {
              id: item.id,
              status: this.state.bulkSelect,
              delivery_from_date: strtdate,
              delivery_to_date: enddate,
            };
          }

          // status_chnage.push({ id: item.id, status: this.state.bulkSelect, delivery_from_date: this.state.delivery_from_date, delivery_to_date: this.state.delivery_to_date });
          // cancel_arr.push({id:item.id ,cancelreason:this.state.ordercancelreason})
          return {
            id: item.id,
            status: this.state.bulkSelect,
            delivery_from_date: this.state.delivery_from_date,
            delivery_to_date: this.state.delivery_to_date,
          };
        }
      });

      updateOrderStatus(
        // status_chnage,
        // // this.state.expectedDate,
        // obj
        status_chnage,
        this.state.ordercancelreason,
        this.state.cancel_message,
        obj,
      )
        .then(() => {
          this.searchData();
        })
        .catch(() => {
          this.searchData();
        });
      this.setState({
        selected_id: [],
        bulkSelect: "",
        ordercancelreason: "",
        cancel_message: "",
        ordercancelreasonError: null,
        cancelorderModal: false,
        supplierModal: false,
      });
    }
  }
  closeCancelOrderModal() {
    this.setState({
      selected_id: [],
      bulkSelect: "",
      ordercancelreason: "",
      supplierModal: "",
      ordercancelreasonError: null,
      isdaterangepickerOpen: false,
      isdatepickeron: false,
    });
    this.setState({
      cancelorderModal: false,
      // ,
      // supplierModal : false
    });
    this.searchData();
  }
  submitNotificationModal() {
    this.setState({
      processing: true,
      isLoading: true,
    });
    // const FileDownload = require('js-file-download');
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    sendNotificationSMS(this.state.p_orderid, this.state.notificationtype, obj)
      .then((res) => {
        this.setState({
          shownotificationmodal: false,
        });
        this.hideAlert();

        this.setState({
          showSmsMessageModal: true,
          smsMessage: res.data.message,
          processing: false,
          isLoading: false,
        });

        this.searchData();
      })
      .catch((error) => {
        this.handleNetworkError("bl");
      });
  }

  submitriderdetailsModal() {
    let error = false;
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var rider_cour = null;
    var is_courier_partner = 0;
    this.setState({ btn_disabled: true });
    this.setState({ btn_text: "Processing" });
    this.hideAlert();
    if (this.state.currier_disabled == "yes") {
      is_courier_partner = 0;
      if (this.state.rider_info == null) {
        error = true;
        this.setState({
          rider_infoError: (
            <small className="text-danger">Rider is required.</small>
          ),
        });
      } else {
        rider_cour = this.state.rider_info.value;

        this.setState({ rider_infoError: null });
      }
    } else {
      is_courier_partner = 1;
      if (this.state.currier_id == null) {
        error = true;
        this.setState({
          currier_idError: (
            <small className="text-danger">Currier is required.</small>
          ),
        });
      } else {
        this.setState({ currier_idError: null });
      }
    }
    if (!error) {
      if (this.state.currier_disabled == "yes") {
        rider_cour = this.state.rider_info.value;
      } else {
        rider_cour = this.state.currier_id.value;
      }

      let order_id = [];
      this.state.selected_id.map((item) => {
        if (item.id != "") {
          order_id.push(item.id);
        }
      });

      updateOrdersRider(
        order_id,
        rider_cour,
        this.state.bulkSelect,
        is_courier_partner,
        this.state.tracking_id,
        this.state.tracking_url,
        this.state.tracking_note,
        this.state.store,
        obj,
      ).then((res) => {
        if (res.data.success == true) {
          console.log("Success", res);
          this.searchData();
          this.setState({
            btn_text: "Submit",
            selected_id: [],
            ridermodel: false,
            bulkSelect: "",
            rider_info: null,
            rider_infoError: null,
            currier_id: null,
            currier_idError: null,
            tracking_id: "",
            tracking_url: "",
            tracking_note: "",
            is_checked: [],
            processing: false,
            is_currier: false,
            currier_disabled: "yes",
          });
        } else {
          console.log("failed", res);
          this.setState({
            ridermodel: false,
            alert: (
              <SweetAlert
                className="order_alert"
                style={{ display: "block", marginTop: "-100px" }}
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="info"
              >
                <h4>{res.data.data.error.message}</h4>
              </SweetAlert>
            ),
          });
        }
      });
    }
  }
  closeriderdetailsModal() {
    this.setState({
      selected_id: [],
      ridermodel: false,
      bulkSelect: "",
      rider_info: null,
      rider_infoError: null,
      currier_id: null,
      currier_idError: null,
      is_checked: [],
      tracking_id: "",
      tracking_note: "",
      tracking_url: "",
      is_currier: false,
      currier_disabled: "yes",
      insuremeBannerText: null,
    });
    this.searchData();
  }
  // collapsing(id) {
  //   var arr = this.state.notedisplay;
  //   arr.map((r, x) => {
  //     if (x === id) {
  //       if (arr[id] == true) {
  //         arr[id] = false;
  //       } else {
  //         arr[id] = true;
  //       }
  //     } else {
  //       arr[x] = false;
  //     }
  //   });
  //   this.setState({ notedisplay: arr });
  // }

  getb2bdata = (cus) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({
      order_b2bcontact_details: [],
    });

    var b2bId = "";
    if (cus.lead.organization_id) {
      b2bId = cus.lead.organization_id;
      getb2bdetail(b2bId, obj)
        .then((response) => {
          if (response.success) {
            this.setState({
              order_b2bcontact_details: response.data.contacts,
            });
          } else {
            this.handleNetworkError("bl");
          }
        })
        .catch(() => {
          //
        });
    }
  };

  removeb2bdetails = () => {
    this.setState({
      order_b2bcontact_details: [],
    });
  };

  handlrTimeZone(order_display_date) {
    const utcMoment = moment.utc(order_display_date);
    const localMoment = utcMoment.local();
    return localMoment.format("YYYY-MM-DD HH:mm:ss A");
  }

  OrderSubTypeSelectOnChange(value) {
    this.setState({ orderSubType: value });
  }

  handleValidityDateChange = (date) => {
    if (moment.isMoment(date)) {
      const dateOnly = date.format("YYYY-MM-DD");
      this.setState({ validityDate: dateOnly, validityDateError: null });
    } else {
      this.setState({ validityDate: null });
    }
  };
  valid = (current) => {
    const today = moment().startOf("day");
    return current.isSameOrAfter(today);
  };
  claimConfirmation = (orderId) => {
    this.setState({
      alert: (
        <SweetAlert
          className="order_alert"
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure ?"
          onConfirm={() => this.submitClaimConfirmation(orderId)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          cancelBtnText="Cancel"
          showCancel
        >
          <h4>you want to confirm this insureme claim order</h4>
        </SweetAlert>
      ),
    });
  };

  submitClaimConfirmation = (orderId) => {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    submitInsuremeClaimConfirmation(orderId, obj).then((res) => {
      if (res.data.status === 200) {
        this.hideAlert();
        this.setState({
          alert: (
            <SweetAlert
              lassName="order_alert"
              style={{ display: "block", marginTop: "-100px" }}
              success
              title="Request Confirmed"
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
            >
              <h4>{res.data.message}</h4>
            </SweetAlert>
          ),
        });
      } else {
        this.hideAlert();
        this.setState({
          alert: (
            <SweetAlert
              lassName="order_alert"
              style={{ display: "block", marginTop: "-100px" }}
              error
              title={res.data.error.message}
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
            >
              <h4>&nbsp;</h4>
            </SweetAlert>
          ),
        });
      }
    });
  };

  uploadDocumentConfirmation = (prescription) => {
    this.setState({
      alert: (
        <SweetAlert
          className="order_alert"
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure ?"
          onConfirm={() => this.insuremeDocumentUpload(prescription)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          cancelBtnText="Cancel"
          showCancel
        >
          <h4>you want to upload the documents to insureme ?</h4>
        </SweetAlert>
      ),
    });
  };

  uploadFileToInsureme = async (obj, file) => {
    const fdata = new FormData();
    fdata.append(`file`, file);
    try {
      const res = await insuremeUploadDocument(fdata, obj);
      if (res.statusCode === 200) {
        this.hideAlert();
        this.setState({
          alert: (
            <SweetAlert
              lassName="order_alert"
              style={{ display: "block", marginTop: "-100px" }}
              success
              title="Document uploaded Successfully"
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
            >
              <h4>{res.data.message}</h4>
            </SweetAlert>
          ),
        });
      } else {
        this.hideAlert();
        this.setState({
          alert: (
            <SweetAlert
              lassName="order_alert"
              style={{ display: "block", marginTop: "-100px" }}
              error
              title={res.data.error.message}
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
            >
              <h4>&nbsp;</h4>
            </SweetAlert>
          ),
        });
      }
      return res;
    } catch (e) {
      return e;
    }
  };

  insuremeDocumentUpload = async (prescription) => {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    if (prescription.length > 0) {
      await Promise.all(
        prescription.map(async (file) => {
          const res = await fetch(file.prescription_url);
          const blob = await res.blob();
          const extension = getFileExtensionFromMimeType(blob.type);
          console.log("extension", extension);
          const blobFile = new File(
            [blob],
            `${file.prescription_url.id}.${extension}`,
            {
              type: blob.type,
            },
          );
          const uploadedDetails = await this.uploadFileToInsureme(
            obj,
            blobFile,
          );
        }),
      );
    } else {
      this.setState({
        alert: (
          <SweetAlert
            lassName="order_alert"
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
          >
            <h4>Please upload the Prescription</h4>
          </SweetAlert>
        ),
      });
    }
  };
  NavigateToCreateLeads() {
    this.props.history.push("/admin/addlead");
  }

  handleCreateToken = (orderId) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        window.open(
          `${process.env.REACT_APP_BILL_GENERATE_URL}/token/${orderId}`,
          "_blank",
        );
        resolve();
      }, 300);
    });
  };

  checkIsEligibleToShowOrderButton(riderDetails, paymentMethod, paymentType) {
    if (
      (riderDetails &&
        riderDetails.name === "Self Pickup" &&
        paymentMethod === "Card" &&
        paymentMethod &&
        paymentType === "success") ||
      this.state.useraccess === 1
    ) {
      return true;
    }
    return false;
  }

  render() {
    const { b2bEmail } = this.state;
    const view = <Tooltip id="view">View Profile</Tooltip>;
    const edit = <Tooltip id="edit">Edit</Tooltip>;
    const cancelModal = <Tooltip id="cancel">Cancel Bill</Tooltip>;
    const payment = <Tooltip id="payment">Complete Order</Tooltip>;
    const quote = <Tooltip id="quote">Quote</Tooltip>;
    const remove = <Tooltip id="remove">Remove</Tooltip>;
    const charge = <Tooltip id="charge">Charge</Tooltip>;
    const notification = <Tooltip id="remove">Send PN / SMS</Tooltip>;
    const replicate = <Tooltip id="replicate">Replicate Order</Tooltip>;
    const claimConfirmation = <Tooltip id="cc">Claim confirmation</Tooltip>;
    const token = <Tooltip id="token">Token</Tooltip>;
    const insuremeDocumentUpload = (
      <Tooltip id="cc">Insureme document upload</Tooltip>
    );
    const completeOrderOnGo = (
      <Tooltip id="completeOrderOnGo">Complete the order one click</Tooltip>
    );
    const leadInfo = (props) => (
      <Tooltip id="button-tooltip" {...props}>
        Simple tooltip
      </Tooltip>
    );
    const errormessages = this.state.errormessages;
    const order_details = this.state.order_details;
    const order_data = this.state.order_chk;

    const order_status_arr = {
      1: "Submitted",
      2: "Processing",
      3: "Dispatched",
      4: "Completed",
      5: "Cancelled",
      6: "Attempted",
      7: "Unreachable",
      8: "Payment Pending",
      9: "Quote Sent",
      10: "Contacted",
      11: "Packed",
      12: "Ready",
      13: "Draft",
      14: " Item Pending",
      16: "Partially Delivered",
      17: "Procurement Ready",
      18: "Hold",
      19: "Order On Move",
    };
    const order_source_arr = {
      1: "Flash",
      2: "oPharma",
      3: "MyPharma",
      4: "Daraz",
      5: "Pickme",
      6: "E-channeling",
      7: "Uber",
      8: "Heart 2 Heart",
      9: "Vida",
      10: "PetDoc",
      11: "LankaRemit",
      12: "ComBankFlash",
      13: "LiweCommunities",
      14: "Synergyit",
      15: "Delta",
    };
    const order_delivery_type = { 1: "Normal", 2: "Express" };
    var c = 1;
    return (
      <div className="main-content">
        <div className="sticky_header">
          <div
            className={
              this.state.normal_data.past_orders_count > 0
                ? "remider_awaiting urgent_banner"
                : "remider_awaiting sucess_banner"
            }
          >
            Pending Normal Order :&nbsp;&nbsp;
            <b>
              {this.state.normal_data.total_orders}(
              {this.state.normal_data.past_orders_count})
            </b>
          </div>
          <div
            class={
              this.state.express_data.past_orders_count > 0
                ? "remider_awaiting urgent_banner"
                : "remider_awaiting sucess_banner"
            }
          >
            Pending Express Order : &nbsp;&nbsp;
            <b>
              {this.state.express_data.total_orders}(
              {this.state.express_data.past_orders_count}){" "}
            </b>
          </div>
          <div class={"remider_awaiting count_Banner"}>
            Count : &nbsp;&nbsp;
            <b>{this.state.resultCount} </b>
          </div>
        </div>

        {this.state.pdfloading ? <LoadingPdfSpinner /> : ""}
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col className="fl_orderlist" md={12}>
              <Card
                tableFullWidth
                content={
                  <React.Fragment>
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          className="text-right"
                        >
                          {this.state.useraccess === 18 ? (
                            <>
                              <Button
                                className="fl_btn_add_order btn-fill"
                                class="btn-color"
                                fill
                                style={{
                                  background: "#FF9013",
                                  border: "none",
                                }}
                                onClick={this.NavigateToCreateLeads.bind(this)}
                              >
                                Create Leads <i className="fa fa-plus"></i>
                              </Button>
                              &nbsp;&nbsp;
                              <Button
                                className="fl_btn_add_order btn-fill"
                                class="btn-color"
                                fill
                                onClick={this.addorder.bind(this)}
                                style={{ display: "none" }}
                              >
                                Add Order <i className="fa fa-plus"></i>
                              </Button>
                            </>
                          ) : (
                            <>
                              <Button
                                className="fl_btn_add_order btn-fill"
                                class="btn-color"
                                fill
                                onClick={this.openModal}
                                style={{ display: "none" }}
                              >
                                Add Order <i className="fa fa-plus"></i>
                              </Button>
                              &nbsp;
                              <Button
                                className="fl_btn_add_order btn-fill"
                                class="btn-color"
                                fill
                                onClick={this.openModal}
                              >
                                Add Order New <i className="fa fa-plus"></i>
                              </Button>
                            </>
                          )}
                        </Col>
                      </Col>
                    </Row>
                    <div>
                      <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                          <Col
                            md={3}
                            sm={4}
                            lg={3}
                            xs={12}
                            className="fl_status_dropdown"
                          >
                            <select
                              onChange={this.onStatusChange}
                              name="bulkSelect"
                              value={this.state.bulkSelect}
                              className="form-control"
                            >
                              <option value="">Select Status</option>
                              <option value="1">Submitted</option>
                              <option value="10">Contacted</option>
                              <option value="2">Processing</option>
                              <option value="11">Packed</option>
                              <option value="3">Dispatched</option>
                              <option value="5">Cancelled</option>
                              <option value="6">Attempted</option>
                              <option value="7">Unreachable</option>
                              <option value="8">Pending</option>
                              <option value="12">Ready</option>
                              <option value="13">Draft</option>
                              <option value="14">Item Pending</option>
                              <option value="16">Partially Delivered</option>
                              <option value="17">Procurement Ready</option>
                              <option value="18">Hold</option>
                              <option value="19">Order On Move</option>
                            </select>
                          </Col>
                          <Col md={3} sm={4} lg={3} xs={12}>
                            <Button
                              className="fl_btn_change_order_status btn-fill"
                              class="btn-color"
                              fill
                              disabled={this.state.isDisableChangeStatusButton}
                              onClick={this.handleUpdateStatus.bind(this)}
                            >
                              Change Order Status
                            </Button>
                          </Col>
                        </Col>
                      </Row>
                    </div>
                    <br />
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <Row
                          className="OrderList_fill"
                          style={{
                            borderRadius: "5px",
                            paddingTop: "11px",
                            paddingBottom: "0px",
                            width: "98%",
                            marginLeft: "7px",
                          }}
                        >
                          <Row>
                            <Col
                              md={12}
                              sm={12}
                              lg={12}
                              xs={12}
                              width
                              style={{ marginBottom: "8px" }}
                            >
                              <Col
                                md={12}
                                sm={12}
                                lg={12}
                                xs={12}
                                className="fl_mb _1"
                                style={{
                                  paddingLeft: "18px",
                                  width: "18%",
                                  position: "relative",
                                  right: "6px",
                                }}
                              >
                                <FormControl
                                  style={{ textAlign: "center" }}
                                  name="subscriber"
                                  value={this.state.subscriber || ""}
                                  placeholder="Subscriber"
                                  onChange={this.onChange}
                                  type="text"
                                />
                              </Col>
                              <Col
                                md={12}
                                sm={12}
                                lg={12}
                                xs={12}
                                className="fl_mb_1"
                                style={{ paddingTop: "4px", width: "15%" }}
                              >
                                <select
                                  name="source"
                                  onChange={this.onChange}
                                  value={this.state.source}
                                  className="form-control"
                                >
                                  <option value="">Source</option>
                                  <option value="1">Flash</option>
                                  <option value="2">oPharma</option>
                                  <option value="3">MyPharma</option>
                                  <option value="4">Daraz</option>
                                  <option value="5">Pickme</option>
                                  <option value="6">E-channeling</option>
                                  <option value="7">Uber</option>
                                  <option value="8">Heart 2 Heart</option>
                                  <option value="9">Vida</option>
                                  <option value="10">PetDoc</option>
                                  <option value="11">LankaRemit</option>
                                  <option value="12">ComBankFlash</option>
                                  <option value="13">LiweCommunities</option>
                                  <option value="14">Synergyit</option>
                                </select>
                              </Col>
                              <Col
                                md={1}
                                sm={1}
                                lg={1}
                                xs={12}
                                className="fl_mb_1"
                                style={{ paddingTop: "4px", width: "15%" }}
                              >
                                <select
                                  name="status"
                                  onChange={this.onChange}
                                  value={this.state.status}
                                  className="form-control"
                                >
                                  <option value="">Order Status</option>
                                  <option value="1">Submitted</option>
                                  <option value="10">Contacted</option>
                                  <option value="2">Processing</option>
                                  <option value="11">Packed</option>
                                  <option value="3">Dispatched</option>
                                  <option value="4">Completed</option>
                                  <option value="5">Cancelled</option>
                                  <option value="6">Attempted</option>
                                  <option value="7">Unreachable</option>
                                  <option value="8">Pending</option>
                                  <option value="12">Ready</option>
                                  <option value="13">Draft</option>
                                  <option value="14">Item Pending</option>
                                  <option value="9">Quote Sent</option>
                                  <option value="16">
                                    Partially Delivered
                                  </option>
                                  <option value="17">Procurement Ready</option>
                                  <option value="18">Hold</option>
                                  <option value="19">Order On Move</option>
                                </select>
                              </Col>
                              {!this.state.is_courier_partner ? (
                                <Col
                                  md={1}
                                  sm={1}
                                  lg={1}
                                  xs={12}
                                  className="fl_mb_1"
                                  style={{ paddingTop: "4px", width: "15%" }}
                                >
                                  <select
                                    type="text"
                                    name="rider_id"
                                    class="form-control"
                                    onChange={this.onChange2}
                                    value={this.state.rider_id}
                                  >
                                    <option value="">Select Rider</option>
                                    {this.state.allRiderData.map((r) => (
                                      <option value={r.id}>{r.name}</option>
                                    ))}
                                  </select>
                                </Col>
                              ) : (
                                <Col
                                  md={1}
                                  sm={1}
                                  lg={1}
                                  xs={12}
                                  className="fl_mb_1"
                                  style={{ paddingTop: "4px", width: "15%" }}
                                >
                                  <select
                                    type="text"
                                    name="courier_partner"
                                    class="form-control"
                                    onChange={this.onChange2}
                                    value={this.state.courier_partner}
                                  >
                                    <option value="">
                                      Select Courier Partner
                                    </option>
                                    {this.state.currier_details.map((r) => (
                                      <option value={r.id}>{r.name}</option>
                                    ))}
                                  </select>
                                </Col>
                              )}
                              <Col
                                md={3}
                                sm={4}
                                lg={1}
                                xs={12}
                                className="fl_mb_1"
                                style={{ paddingTop: "4px", width: "15%" }}
                              >
                                <select
                                  name="delivery_Type"
                                  onChange={this.onChange}
                                  value={this.state.delivery_Type}
                                  className="form-control"
                                >
                                  <option value="">Delivery Type</option>
                                  <option value="1">Standard</option>
                                  <option value="2">Express</option>
                                  <option value="3">Island Wide</option>
                                </select>
                              </Col>
                              <Col
                                md={1}
                                sm={1}
                                lg={1}
                                xs={12}
                                className="fl_mb_1"
                                style={{
                                  paddingRight: "5px",
                                  marginTop: "5px",
                                }}
                              >
                                <Button
                                  class="btn-color"
                                  style={{ width: "100%" }}
                                  fill
                                  onClick={this.searchdata.bind(this)}
                                >
                                  Filter
                                </Button>
                              </Col>
                              <Col
                                md={1}
                                sm={1}
                                lg={1}
                                xs={12}
                                className="fl_mb_1"
                                style={{
                                  paddingRight: "5px",
                                  marginTop: "5px",
                                }}
                              >
                                <Button
                                  class="btn-color"
                                  style={{ width: "100%" }}
                                  fill
                                  onClick={this.resetSearch.bind(this)}
                                >
                                  Reset
                                </Button>
                              </Col>
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              md={12}
                              sm={12}
                              lg={12}
                              xs={12}
                              style={{ marginBottom: "-3px !important" }}
                            >
                              <Col
                                md={1}
                                sm={1}
                                lg={1}
                                xs={12}
                                className="fl_mb_2 fl_datepicker"
                                style={{
                                  paddingLeft: "18px",
                                  width: "18%",
                                  position: "relative",
                                  marginTop: "5px",

                                  // right: "6px",
                                }}
                              >
                                <Datetime
                                  timeFormat={false}
                                  dateFormat="YYYY-MM-DD"
                                  inputProps={{ placeholder: "Order Date" }}
                                  closeOnSelect={true}
                                  value={this.state.orderdate}
                                  onChange={this.handleDateChange}
                                />
                              </Col>
                              <Col
                                md={1}
                                sm={1}
                                lg={1}
                                xs={12}
                                className="fl_mb_1"
                                style={{ paddingTop: "4px", width: "15%" }}
                              >
                                <select
                                  className="form-control"
                                  placeholder="Payment"
                                  name="paymentoption"
                                  value={this.state.paymentoption}
                                  onChange={this.onChange}
                                >
                                  <option value="">Payment type</option>
                                  <option value="Cash">Cash</option>
                                  <option value="Card">Card</option>
                                  <option value="Cheque">Cheque</option>
                                  <option value="InsureMe">InsureMe</option>
                                  <option value="Bank Transfer">
                                    Bank Transfer
                                  </option>
                                  <option value="Hybrid">Hybrid</option>
                                  <option value="CeyPay">CeyPay</option>
                                  <option value="Swap Machine">
                                    Swap Machine
                                  </option>
                                  <option value="Mintpay">Mintpay</option>
                                </select>
                              </Col>
                              <Col
                                md={3}
                                sm={4}
                                lg={1}
                                xs={12}
                                className="fl_mb_2"
                                style={{ paddingTop: "4px", width: "15%" }}
                              >
                                <Col>
                                  <FormGroup>
                                    <Select
                                      name="b2b"
                                      value={this.state.b2b}
                                      placeholder="B2B Company"
                                      onChange={(value) =>
                                        this.onParentOrganizationChange(value)
                                      }
                                      options={this.state.b2bDetails}
                                    />
                                  </FormGroup>
                                </Col>
                                {/* <select
                                  name="b2b"
                                  onChange={this.onChange}
                                  value={this.state.b2b}
                                  className="form-control"
                                >
                                  <option value="">B2B Company</option>
                                  {this.state.b2bDetails.map((b) => (
                                    <option value={b.company_name}>
                                      {b.company_name}
                                    </option>
                                  ))}
                                </select> */}
                              </Col>
                              <Col
                                md={3}
                                sm={4}
                                lg={1}
                                xs={12}
                                className="fl_mb_1"
                                style={{ paddingTop: "4px", width: "15%" }}
                              >
                                <select
                                  name="channel_filter"
                                  onChange={this.onChange}
                                  value={this.state.channel_filter}
                                  className="form-control"
                                >
                                  <option value="">Channel</option>
                                  <option value="admin">Admin</option>
                                  <option value="app">App</option>
                                  <option value="web">Web</option>
                                  <option value="flash_consult">
                                    First advice
                                  </option>
                                </select>
                              </Col>
                              <Col
                                md={3}
                                sm={4}
                                lg={1}
                                xs={12}
                                className="fl_mb_1"
                                style={{ paddingTop: "4px", width: "15%" }}
                              >
                                <select
                                  name="order_type_filter"
                                  onChange={this.onChange}
                                  value={this.state.order_type_filter}
                                  className="form-control"
                                >
                                  <option value="">Order Type</option>
                                  <option value="1">Medicine</option>
                                  <option value="2">Raya</option>
                                </select>
                              </Col>
                              <Col
                                md={3}
                                sm={4}
                                lg={1}
                                xs={12}
                                className="fl_mb_1"
                                style={{ paddingTop: "4px", width: "15%" }}
                              >
                                <select
                                  name="city_id"
                                  onChange={this.onChange}
                                  value={this.state.city_id}
                                  className="form-control"
                                >
                                  <option value="">District</option>
                                  {this.state.city_info.map((b) => (
                                    <option value={b.id}>{b.city_name}</option>
                                  ))}
                                </select>
                              </Col>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={12} sm={12} lg={12} xs={12}>
                              <Col
                                md={1}
                                sm={1}
                                lg={1}
                                xs={12}
                                className="fl_mb _1"
                                style={{
                                  paddingLeft: "18px",
                                  width: "18%",
                                  position: "relative",
                                  right: "6px",
                                }}
                              >
                                <input
                                  type="number"
                                  placeholder="Order Id"
                                  className="form-control"
                                  name="order_id_filter"
                                  value={this.state.order_id_filter}
                                  onChange={this.onChange}
                                ></input>
                              </Col>
                              <Col
                                md={1}
                                sm={1}
                                lg={1}
                                xs={12}
                                className="fl_mb _1"
                                style={{ paddingTop: "4px", width: "15%" }}
                              >
                                <select
                                  name="salesAgentValue"
                                  onChange={(event) =>
                                    this.salesAgentOnChange(event)
                                  }
                                  value={this.state.salesAgentValue}
                                  className="form-control"
                                >
                                  <option value="">Sales Agent</option>
                                  {this.state.salesAgentOptions.map((data) => (
                                    <option value={data.value}>
                                      {data.label}
                                    </option>
                                  ))}
                                </select>
                              </Col>
                              {/* {this.state.settingsData.setting_value ==
                                "true" &&
                                this.state.userData.role === 1 && ( */}
                              {this.state.userData.role === 1 && (
                                <Col
                                  md={1}
                                  sm={1}
                                  lg={1}
                                  xs={12}
                                  className="fl_mb_1 fl_datepicker"
                                  style={{ width: "15%", paddingTop: "4px" }}
                                >
                                  <Select
                                    placeholder="Branch"
                                    options={this.state.branchList}
                                    onChange={(value) => {
                                      this.setState({ branch: value });
                                      this.searchdata();
                                    }}
                                    value={this.state.branch}
                                    isClearable
                                  />
                                </Col>
                              )}
                              {/* )} */}
                              <Col
                                md={1}
                                sm={1}
                                lg={1}
                                xs={12}
                                style={{ marginTop: "5px", width: "15%" }}
                                className="fl_mb_2"
                              >
                                <FormGroup>
                                  <Select
                                    name="orderSubType"
                                    value={this.state.orderSubType}
                                    placeholder="Order Sub Type"
                                    onChange={(value) =>
                                      this.OrderSubTypeSelectOnChange(value)
                                    }
                                    options={[
                                      { value: "1", label: "B2C" },
                                      { value: "2", label: "B2B" },
                                      { value: "3", label: "PickUp" },
                                      { value: "4", label: "Purchase Request" },
                                    ]}
                                  />
                                </FormGroup>
                              </Col>
                              <Col
                                md={3}
                                sm={4}
                                lg={1}
                                xs={12}
                                className="fl_mb_1"
                                style={{ paddingTop: "4px", width: "15%" }}
                              >
                                <input
                                  type="text"
                                  placeholder=" PO Number"
                                  className="form-control"
                                  name="po_number"
                                  value={this.state.po_number}
                                  onChange={this.onChange}
                                ></input>
                              </Col>
                              <Col
                                md={1}
                                sm={1}
                                lg={1}
                                xs={12}
                                className="fl_mb_1 fl_datepicker"
                                style={{ paddingTop: "4px" }}
                              >
                                <Button
                                  style={{ marginTop: "3px" }}
                                  value="Toggle date picker"
                                  onClick={this.onToggle.bind(this)}
                                >
                                  Date Range
                                </Button>
                                {this.state.isdaterangepickerOpen && (
                                  <DateRangePicker
                                    value={this.state.value}
                                    onSelect={this.onSelect}
                                    singleDateRange={true}
                                  />
                                )}
                              </Col>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={12} sm={12} lg={12} xs={12}>
                              <div>
                                <Col
                                  md={1}
                                  sm={1}
                                  lg={1}
                                  xs={12}
                                  className="fl_mb_1"
                                  style={{
                                    width: "10%",
                                  }}
                                >
                                  <Checkbox
                                    number="569"
                                    checked={this.state.is_claimable === "1"}
                                    onChange={this.isClaimableTrue}
                                    label="Is Claimable ?"
                                  />
                                </Col>
                              </div>
                              <div>
                                <Col
                                  md={1}
                                  sm={1}
                                  lg={1}
                                  xs={12}
                                  className="fl_mb_1"
                                >
                                  <Checkbox
                                    number="566"
                                    checked={this.state.partial_sent}
                                    onChange={(e) => this.isPartialTrue(e)}
                                    label="Is Partial ?"
                                  ></Checkbox>
                                </Col>
                              </div>
                              <div>
                                <Col
                                  md={1}
                                  sm={1}
                                  lg={1}
                                  xs={12}
                                  className="fl_mb_1"
                                >
                                  <Checkbox
                                    number="565"
                                    checked={this.state.is_courier_partner}
                                    onChange={(e) => this.isCurrierPartner(e)}
                                    label="Is Courier ?"
                                  ></Checkbox>
                                </Col>
                              </div>
                            </Col>
                          </Row>
                        </Row>
                        <br></br>
                        <Col md={12} sm={12} lg={12} xs={12}>
                          <Table responsive className="order_list_table_show">
                            <thead>
                              <tr>
                                <th>
                                  <input
                                    type="checkbox"
                                    onClick={this.handleAllChecked}
                                    value="checkedall"
                                  />{" "}
                                </th>
                                <th></th>
                                <th>#Id</th>
                                <th>Subscriber</th>
                                <th>Order Date</th>
                                <th>Total Cost</th>
                                <th>Source</th>
                                <th>Status</th>
                                <th>Rider Name</th>
                                {this.state.useraccess !== 18 &&
                                this.state.useraccess === 1 ? (
                                  <th>Store</th>
                                ) : null}
                                <th>Pending Amount</th>
                                <th>Payment Type</th>
                                <th>Pending Status</th>
                                <th>Invoice</th>
                                <th className="text-right">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.loading ? (
                                <tr>
                                  <td colspan="10">
                                    <LoadingSpinner />
                                  </td>
                                </tr>
                              ) : this.state.noRecordFound ? (
                                <tr>
                                  <td colspan="12">
                                    <center>No record found</center>
                                  </td>
                                </tr>
                              ) : (
                                <React.Fragment>
                                  {order_data.map((cus) => (
                                    <tr
                                      className={
                                        cus.is_viewed_by_admin == "0" ||
                                        (cus.source == 8 &&
                                          cus.order_status == 1)
                                          ? "red_background"
                                          : "" +
                                            (cus.delivery_type == 2
                                              ? " express_row"
                                              : "")
                                      }
                                      style={
                                        cus.delivery_type == 2
                                          ? {
                                              backgroundColor: "#fff8f0",
                                            }
                                          : {}
                                      }
                                    >
                                      <td>
                                        <input
                                          key={cus.id}
                                          onClick={
                                            this.handleCheckChieldElement
                                          }
                                          type="checkbox"
                                          checked={cus.isChecked}
                                          value={cus.id}
                                          disabled={cus.isDisabled}
                                        />{" "}
                                      </td>
                                      <td>
                                        {cus.channel == "app" ? (
                                          <i
                                            className="fa fa-mobile"
                                            style={{ fontSize: "25px" }}
                                          ></i>
                                        ) : cus.channel == "web" ? (
                                          <i
                                            className="fa fa-desktop"
                                            style={{ fontSize: "17px" }}
                                          ></i>
                                        ) : (
                                          ""
                                        )}
                                        {cus.channel == "flash_consult" ? (
                                          <i
                                            className="fa fa-user"
                                            style={{ fontSize: "25px" }}
                                          ></i>
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                      <td>{cus.id}</td>
                                      <td
                                        style={{
                                          textTransform: "capitalize",
                                          // whiteSpace: "nowrap",
                                        }}
                                      >
                                        {cus.lead.name.toLowerCase()}
                                        {cus.delivery_type == 2 && (
                                          <span
                                            style={{
                                              background: "#FF6A00",
                                              color: "#fff",
                                              borderRadius: "12px",
                                              padding: "3px 8px",
                                              marginLeft: "8px",
                                              fontSize: "11px",
                                              fontWeight: 600,
                                              verticalAlign: "middle",
                                            }}
                                          >
                                            EXPRESS
                                          </span>
                                        )}
                                        {cus.order_sub_type == 3 && (
                                          <span
                                            style={{
                                              background: "#FF3838",
                                              color: "#fff",
                                              borderRadius: "12px",
                                              padding: "3px 8px",
                                              marginLeft: "8px",
                                              fontSize: "11px",
                                              fontWeight: 600,
                                              verticalAlign: "middle",
                                            }}
                                          >
                                            PICKUP
                                          </span>
                                        )}
                                        {cus.order_sub_type == 4 && (
                                          <span
                                            style={{
                                              background: "#08CB00",
                                              color: "#fff",
                                              borderRadius: "12px",
                                              padding: "3px 8px",
                                              marginLeft: "8px",
                                              fontSize: "11px",
                                              fontWeight: 600,
                                              verticalAlign: "middle",
                                            }}
                                          >
                                            PR{cus.pr_id}
                                          </span>
                                        )}
                                      </td>
                                      <td style={{ whiteSpace: "nowrap" }}>
                                        {this.handlrTimeZone(
                                          cus.order_display_date,
                                        )}
                                      </td>
                                      <td>{(cus.total_cost - 0).toFixed(2)}</td>
                                      <td className="no-padding">
                                        {order_source_arr[cus.source]}
                                      </td>
                                      {cus.order_status == 1 ||
                                      cus.order_status == 2 ? (
                                        <td
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <p
                                            className="btn btn-fill "
                                            style={{
                                              backgroundColor:
                                                cus.order_status == 1
                                                  ? "#FFA823"
                                                  : cus.order_status == 2
                                                    ? "#A91079"
                                                    : "",
                                              border:
                                                cus.order_status == 1
                                                  ? "none"
                                                  : cus.order_status == 2
                                                    ? "none"
                                                    : "",
                                            }}
                                          >
                                            <span
                                              style={{
                                                display: "block",
                                                fontSize: "10px",
                                              }}
                                            >
                                              {
                                                order_status_arr[
                                                  cus.order_status
                                                ]
                                              }
                                            </span>
                                            {cus.order_status == 2 &&
                                            cus.process_start_time !== null ? (
                                              <span
                                                style={{
                                                  display: "block",
                                                  fontSize: "8px",
                                                }}
                                              >
                                                {moment(
                                                  cus.process_start_time,
                                                ).format("YYYY/MM/DD HH:mm:ss")}
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                          </p>
                                          {cus.order_status == 2 &&
                                          moment(new Date()).diff(
                                            moment(
                                              new Date(cus.process_start_time),
                                            ),
                                            "days",
                                          ) >= 3 ? (
                                            <i>
                                              <img
                                                style={{ marginLeft: "10px" }}
                                                src="https://s3.ap-south-1.amazonaws.com/admin-dev.flash.health/red-alert-icon.svg"
                                                width="25px"
                                                height="25px"
                                              />
                                            </i>
                                          ) : (
                                            ""
                                          )}
                                          {cus.order_status == 1 &&
                                          cus.order_sub_type === 1 &&
                                          moment(new Date()).diff(
                                            moment(new Date(cus.created_at)),
                                            "minute",
                                          ) > 20 ? (
                                            <i>
                                              <img
                                                style={{ marginLeft: "10px" }}
                                                src="https://s3.ap-south-1.amazonaws.com/admin-dev.flash.health/red-alert-icon.svg"
                                                width="25px"
                                                height="25px"
                                              />
                                            </i>
                                          ) : (
                                            ""
                                          )}
                                          {cus.is_claimable === "1" && (
                                            <i
                                              style={{
                                                fontSize: "14px",
                                                background: "red",
                                                color: "white",
                                                borderRadius: "5px",
                                                margin: "5px",
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                              }}
                                            >
                                              CLAIM
                                            </i>
                                          )}
                                          {cus.partial_sent === true && (
                                            <i
                                              style={{
                                                fontSize: "14px",
                                                background: "blue",
                                                color: "white",
                                                borderRadius: "5px",
                                                margin: "5px",
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                              }}
                                            >
                                              Partial
                                            </i>
                                          )}
                                        </td>
                                      ) : cus.order_status == 3 ? (
                                        <td className="">
                                          <p className="btn btn-fill fl_text_navyBlue ">
                                            {" "}
                                            <span
                                              style={{
                                                display: "block",
                                                fontSize: "10px",
                                              }}
                                            >
                                              {
                                                order_status_arr[
                                                  cus.order_status
                                                ]
                                              }
                                            </span>
                                            {cus.order_status == 3 &&
                                            cus.dispatch_start_time !== null ? (
                                              <span
                                                style={{
                                                  display: "block",
                                                  fontSize: "8px",
                                                }}
                                              >
                                                {moment(
                                                  cus.dispatch_start_time,
                                                ).format("YYYY/MM/DD HH:mm:ss")}
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                          </p>
                                          {cus.is_claimable === "1" && (
                                            <i
                                              style={{
                                                fontSize: "14px",
                                                background: "red",
                                                color: "white",
                                                borderRadius: "5px",
                                                margin: "5px",
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                              }}
                                            >
                                              CLAIM
                                            </i>
                                          )}
                                          {cus.partial_sent === true && (
                                            <i
                                              style={{
                                                fontSize: "14px",
                                                background: "blue",
                                                color: "white",
                                                borderRadius: "5px",
                                                margin: "5px",
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                              }}
                                            >
                                              Partial
                                            </i>
                                          )}
                                        </td>
                                      ) : cus.order_status == 4 ? (
                                        <td className="">
                                          <p className="btn btn-fill fl_text_green ">
                                            {" "}
                                            <span
                                              style={{
                                                display: "block",
                                                fontSize: "10px",
                                              }}
                                            >
                                              {
                                                order_status_arr[
                                                  cus.order_status
                                                ]
                                              }
                                            </span>
                                            {cus.completed_time !== null ? (
                                              <span
                                                style={{
                                                  display: "block",
                                                  fontSize: "8px",
                                                }}
                                              >
                                                {moment(
                                                  cus.completed_time,
                                                ).format("YYYY/MM/DD HH:mm:ss")}
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                          </p>
                                          {cus.is_claimable === "1" && (
                                            <i
                                              style={{
                                                fontSize: "14px",
                                                background: "red",
                                                color: "white",
                                                borderRadius: "5px",
                                                margin: "5px",
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                              }}
                                            >
                                              CLAIM
                                            </i>
                                          )}
                                          {cus.partial_sent === true && (
                                            <i
                                              style={{
                                                fontSize: "14px",
                                                background: "blue",
                                                color: "white",
                                                borderRadius: "5px",
                                                margin: "5px",
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                              }}
                                            >
                                              Partial
                                            </i>
                                          )}
                                        </td>
                                      ) : cus.order_status == 5 ||
                                        cus.order_status == 8 ? (
                                        <td
                                          style={{ display: "inline-flex" }}
                                          className=""
                                        >
                                          <p className="btn btn-fill fl_text_red">
                                            <span
                                              style={{
                                                display: "block",
                                                fontSize: "10px",
                                              }}
                                            >
                                              {
                                                order_status_arr[
                                                  cus.order_status
                                                ]
                                              }
                                            </span>
                                            {cus.order_status == 8 &&
                                            cus.payment_pending_start_time !==
                                              null ? (
                                              <span
                                                style={{
                                                  display: "block",
                                                  fontSize: "8px",
                                                }}
                                              >
                                                {moment(
                                                  cus.payment_pending_start_time,
                                                ).format("YYYY/MM/DD HH:mm:ss")}
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                          </p>
                                          {cus.order_status == "5" ? (
                                            <i
                                              className="fa fa-ban"
                                              onClick={this.open_cancel_reason_display_Modal.bind(
                                                this,
                                                cus.cancel_reason,
                                                cus.cancel_message,
                                              )}
                                              title="Show Order Cancel reason "
                                            ></i>
                                          ) : (
                                            ""
                                          )}
                                          {cus.is_claimable === "1" && (
                                            <i
                                              style={{
                                                fontSize: "14px",
                                                background: "red",
                                                color: "white",
                                                borderRadius: "5px",
                                                margin: "5px",
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                              }}
                                            >
                                              CLAIM
                                            </i>
                                          )}
                                          {cus.partial_sent === true && (
                                            <i
                                              style={{
                                                fontSize: "14px",
                                                background: "blue",
                                                color: "white",
                                                borderRadius: "5px",
                                                margin: "5px",
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                              }}
                                            >
                                              Partial
                                            </i>
                                          )}
                                        </td>
                                      ) : cus.order_status == 9 ? (
                                        <td
                                          style={{ display: "inline-flex" }}
                                          className=""
                                        >
                                          <p className="btn btn-fill ">
                                            <span
                                              style={{
                                                display: "block",
                                                fontSize: "10px",
                                              }}
                                            >
                                              {
                                                order_status_arr[
                                                  cus.order_status
                                                ]
                                              }
                                            </span>
                                          </p>
                                          {cus.order_status == "9" ? (
                                            <a
                                              className="fa fa-eye"
                                              href={cus.short_url}
                                              target="_blank"
                                              title="Submit Quote"
                                            ></a>
                                          ) : (
                                            ""
                                          )}
                                          {cus.is_claimable === "1" && (
                                            <i
                                              style={{
                                                fontSize: "14px",
                                                background: "red",
                                                color: "white",
                                                borderRadius: "5px",
                                                margin: "5px",
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                              }}
                                            >
                                              CLAIM
                                            </i>
                                          )}
                                          {cus.partial_sent === true && (
                                            <i
                                              style={{
                                                fontSize: "14px",
                                                background: "blue",
                                                color: "white",
                                                borderRadius: "5px",
                                                margin: "5px",
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                              }}
                                            >
                                              Partial
                                            </i>
                                          )}
                                        </td>
                                      ) : cus.order_status == 12 ? (
                                        <td className="">
                                          <p className="btn btn-fill fl_text_purple">
                                            <span
                                              style={{
                                                display: "block",
                                                fontSize: "10px",
                                              }}
                                            >
                                              {
                                                order_status_arr[
                                                  cus.order_status
                                                ]
                                              }
                                            </span>
                                          </p>
                                          {cus.is_claimable === "1" && (
                                            <i
                                              style={{
                                                fontSize: "14px",
                                                background: "red",
                                                color: "white",
                                                borderRadius: "5px",
                                                margin: "5px",
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                              }}
                                            >
                                              CLAIM
                                            </i>
                                          )}
                                          {cus.partial_sent === true && (
                                            <i
                                              style={{
                                                fontSize: "14px",
                                                background: "blue",
                                                color: "white",
                                                borderRadius: "5px",
                                                margin: "5px",
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                              }}
                                            >
                                              Partial
                                            </i>
                                          )}
                                        </td>
                                      ) : cus.order_status == 14 ? (
                                        <td className="">
                                          <p className="btn btn-fill fl_text_blue">
                                            <span
                                              style={{
                                                display: "block",
                                                fontSize: "10px",
                                              }}
                                            >
                                              {
                                                order_status_arr[
                                                  cus.order_status
                                                ]
                                              }
                                            </span>
                                          </p>
                                          {cus.is_claimable === "1" && (
                                            <i
                                              style={{
                                                fontSize: "14px",
                                                background: "red",
                                                color: "white",
                                                borderRadius: "5px",
                                                margin: "5px",
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                              }}
                                            >
                                              CLAIM
                                            </i>
                                          )}
                                          {cus.partial_sent === true && (
                                            <i
                                              style={{
                                                fontSize: "14px",
                                                background: "blue",
                                                color: "white",
                                                borderRadius: "5px",
                                                margin: "5px",
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                              }}
                                            >
                                              Partial
                                            </i>
                                          )}
                                        </td>
                                      ) : cus.order_status == 10 ? (
                                        <td className="">
                                          <p className="btn btn-fill fl_text_review">
                                            <span
                                              style={{
                                                display: "block",
                                                fontSize: "10px",
                                              }}
                                            >
                                              {
                                                order_status_arr[
                                                  cus.order_status
                                                ]
                                              }
                                            </span>
                                          </p>
                                          {cus.is_claimable === "1" && (
                                            <i
                                              style={{
                                                fontSize: "14px",
                                                background: "red",
                                                color: "white",
                                                borderRadius: "5px",
                                                margin: "5px",
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                              }}
                                            >
                                              CLAIM
                                            </i>
                                          )}
                                          {cus.partial_sent === true && (
                                            <i
                                              style={{
                                                fontSize: "14px",
                                                background: "blue",
                                                color: "white",
                                                borderRadius: "5px",
                                                margin: "5px",
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                              }}
                                            >
                                              Partial
                                            </i>
                                          )}
                                        </td>
                                      ) : (
                                        <td className="">
                                          <p
                                            className="btn btn-fill"
                                            style={{
                                              backgroundColor:
                                                cus.order_status == 11
                                                  ? "#5C3D2E"
                                                  : cus.order_status == 16
                                                    ? "#00008B"
                                                    : cus.order_status == 17
                                                      ? "#2E8B57"
                                                      : cus.order_status == 18
                                                        ? "#800000"
                                                        : cus.order_status == 13
                                                          ? "black"
                                                          : cus.order_status ==
                                                              19
                                                            ? // need a color for Order On Move status it wnat to be eye catching  color
                                                              "#f94144"
                                                            : "",
                                              border:
                                                cus.order_status == 11
                                                  ? "none"
                                                  : cus.order_status == 13
                                                    ? "none"
                                                    : cus.order_status == 19
                                                      ? "none"
                                                      : "",
                                            }}
                                          >
                                            <span
                                              style={{
                                                display: "block",
                                                fontSize: "10px",
                                              }}
                                            >
                                              {
                                                order_status_arr[
                                                  cus.order_status
                                                ]
                                              }
                                            </span>
                                            {cus.order_status == 11 &&
                                            cus.packed_start_time !== null ? (
                                              <span
                                                style={{
                                                  display: "block",
                                                  fontSize: "8px",
                                                }}
                                              >
                                                {moment(
                                                  cus.packed_start_time,
                                                ).format("YYYY/MM/DD HH:mm:ss")}
                                              </span>
                                            ) : cus.order_status == 13 &&
                                              cus.draft_start_time !== null ? (
                                              <span
                                                style={{
                                                  display: "block",
                                                  fontSize: "8px",
                                                }}
                                              >
                                                {moment(
                                                  cus.draft_start_time,
                                                ).format("YYYY/MM/DD HH:mm:ss")}
                                              </span>
                                            ) : cus.order_status == 16 ? (
                                              <span
                                                style={{
                                                  display: "block",
                                                  fontSize: "8px",
                                                }}
                                              >
                                                {moment(
                                                  cus.partially_delivered_start_time,
                                                ).format("YYYY/MM/DD HH:mm:ss")}
                                              </span>
                                            ) : cus.order_status == 17 ? (
                                              <span
                                                style={{
                                                  display: "block",
                                                  fontSize: "8px",
                                                }}
                                              >
                                                {moment(
                                                  cus.procurement_ready_start_time,
                                                ).format("YYYY/MM/DD HH:mm:ss")}
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                          </p>
                                          {cus.is_claimable === "1" && (
                                            <i
                                              style={{
                                                fontSize: "14px",
                                                background: "red",
                                                color: "white",
                                                borderRadius: "5px",
                                                margin: "5px",
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                              }}
                                            >
                                              CLAIM
                                            </i>
                                          )}
                                          {cus.partial_sent === true && (
                                            <i
                                              style={{
                                                fontSize: "14px",
                                                background: "blue",
                                                color: "white",
                                                borderRadius: "5px",
                                                margin: "5px",
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                              }}
                                            >
                                              Partial
                                            </i>
                                          )}
                                        </td>
                                      )}
                                      <td>
                                        {cus.rider_id != null
                                          ? cus.riderdetails != null
                                            ? cus.riderdetails.name
                                            : ""
                                          : ""}
                                      </td>
                                      <td>
                                        {this.state.useraccess !== 18 && (
                                          <td>
                                            {this.state.useraccess === 1 &&
                                              cus.store && (
                                                <span
                                                  className="badge"
                                                  style={{
                                                    backgroundColor:
                                                      cus.store.name
                                                        .trim()
                                                        .toLowerCase() ===
                                                      "colombo"
                                                        ? "#007bff"
                                                        : "#dc3545",
                                                    color: "#fff",
                                                    padding: "10px 10px",
                                                    fontFamily: "sans-serif",
                                                    textTransform: "capitalize",
                                                  }}
                                                >
                                                  {cus.store.name || "-"}
                                                </span>
                                              )}
                                          </td>
                                        )}
                                      </td>
                                      {cus.total_cost == "0" ? (
                                        <td>
                                          {cus.order_status != "4"
                                            ? (cus.total_cost - 0).toFixed(2)
                                            : "-"}
                                        </td>
                                      ) : (
                                        <td>
                                          {cus.order_status != "4"
                                            ? (
                                                cus.total_cost - cus.paid_amount
                                              ).toFixed(2)
                                            : "-"}
                                        </td>
                                      )}
                                      <td>{cus.paymentoption}</td>
                                      <td>
                                        {cus.payment_status && (
                                          <Button
                                            className={`status-cell ${
                                              cus.payment_status === "failed"
                                                ? "failed"
                                                : cus.payment_status ===
                                                    "success"
                                                  ? "success"
                                                  : ""
                                            }`}
                                          >
                                            <span className="payment_status_main">
                                              {cus.payment_status}
                                            </span>
                                          </Button>
                                        )}
                                      </td>
                                      <td>
                                        {" "}
                                        <Button
                                          disabled={!this.state.processing}
                                          onClick={this.downloadinvoice.bind(
                                            this,
                                            cus.id,
                                          )}
                                        >
                                          View
                                        </Button>
                                      </td>
                                      <td className="td-actions text-right no-padding">
                                        {cus.payment_status == "failed" &&
                                          cus.channel == "app" &&
                                          cus.paymentoption == "Card" &&
                                          cus.source == 1 && (
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={charge}
                                            >
                                              <Button
                                                simple
                                                disabled={
                                                  this.state.chargeProcessing
                                                }
                                                bsStyle="success"
                                                bsSize="xs"
                                                onClick={this.warningWithChargeMessage.bind(
                                                  this,
                                                  cus.id,
                                                )}
                                              >
                                                <i class="fa fa-address-card" />
                                              </Button>
                                            </OverlayTrigger>
                                          )}
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={notification}
                                        >
                                          <Button
                                            simple
                                            bsStyle="info"
                                            bsSize="xs"
                                            onClick={this.sendNotification.bind(
                                              this,
                                              cus.id,
                                              cus.total_cost,
                                              cus.paid_amount,
                                              cus.order_status,
                                              // this.setState({
                                              //   oId: cus.id,
                                              // })
                                              // this.setState({
                                              //   oID: cus.id,
                                              // })
                                            )}
                                          >
                                            <i class="fa  fa-bell"></i>
                                          </Button>
                                        </OverlayTrigger>
                                        {cus.doner_id != null ? (
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={
                                              <Tooltip id="button-tooltip">
                                                {cus.doner ? (
                                                  <>
                                                    {cus.doner.name ? (
                                                      <>
                                                        {cus.doner.name}
                                                        <br />
                                                      </>
                                                    ) : (
                                                      ""
                                                    )}
                                                    {/*cus.doner.date_of_birth ? (
                                                      !cus.doner.date_of_birth.includes(
                                                        "NaN-aN-aN"
                                                      ) ? (
                                                        <>
                                                          {
                                                            cus.doner
                                                              .date_of_birth
                                                          }
                                                          <br />
                                                        </>
                                                      ) : (
                                                        ""
                                                      )
                                                    ) : (
                                                      ""
                                                    )*/}
                                                    {cus.doner.mobile_no ? (
                                                      <>
                                                        {cus.doner.mobile_no}
                                                        <br />
                                                      </>
                                                    ) : (
                                                      ""
                                                    )}
                                                    {/*cus.doner.email ? (
                                                      <>
                                                        {cus.doner.email}
                                                        <br />
                                                      </>
                                                    ) : (
                                                      ""
                                                    )*/}
                                                    {/*cus.doner.address_id ? (
                                                      cus.doner.address ? (
                                                        <>
                                                          {cus.doner.address
                                                            .address_line1
                                                            ? cus.doner.address
                                                                .address_line1
                                                            : ""}{" "}
                                                          {cus.doner.address
                                                            .address_line2
                                                            ? cus.doner.address
                                                                .address_line2
                                                            : ""}
                                                        </>
                                                      ) : (
                                                        ""
                                                      )
                                                    ) : (
                                                      ""
                                                    )*/}
                                                  </>
                                                ) : (
                                                  ""
                                                )}
                                              </Tooltip>
                                            }
                                          >
                                            <Button
                                              simple
                                              bsStyle="info"
                                              bsSize="xs"
                                            >
                                              <i
                                                style={{ color: "orange" }}
                                                class="fa fa-heartbeat"
                                                aria-hidden="true"
                                              ></i>
                                            </Button>
                                          </OverlayTrigger>
                                        ) : (
                                          ""
                                        )}
                                        <OverlayTrigger
                                          placement="top"
                                          trigger="focus"
                                          onEntered={() => this.getb2bdata(cus)}
                                          overlay={
                                            <Tooltip id="button-tooltip">
                                              {`${cus.lead.mobile_no}`}
                                              <br />
                                              {`${cus.address.address_line1}`}{" "}
                                              {cus.address.address_line2 != null
                                                ? cus.address.address_line2
                                                : ""}
                                              <br /> <b>Delivery Type</b> :
                                              {cus.delivery_type == 1
                                                ? "Normal"
                                                : "Express"}
                                              {cus.tracking_id ===
                                              null ? null : (
                                                <>
                                                  <br /> <b>Tracking_ID :</b>
                                                </>
                                              )}{" "}
                                              {`${
                                                cus.tracking_id === null
                                                  ? ""
                                                  : cus.tracking_id
                                              }`}
                                              {cus.tracking_id ===
                                              null ? null : (
                                                <>
                                                  <br />
                                                  <b>Tracking_URL :</b>
                                                </>
                                              )}{" "}
                                              {`${
                                                cus.tracking_url === null
                                                  ? ""
                                                  : cus.tracking_url
                                              }`}
                                              {cus.tracking_id ===
                                              null ? null : (
                                                <>
                                                  <br /> <b>Tracking_Note :</b>
                                                </>
                                              )}{" "}
                                              {cus.secondary_name && (
                                                <>
                                                  <br />
                                                  <b>secondary Name:</b>{" "}
                                                  {cus.secondary_name}
                                                </>
                                              )}
                                              {cus.secondary_number && (
                                                <>
                                                  <br />
                                                  <b>secondary Number:</b>{" "}
                                                  {cus.secondary_number}
                                                </>
                                              )}
                                              {this.state
                                                .order_b2bcontact_details
                                                .length > 0
                                                ? this.state.order_b2bcontact_details.map(
                                                    (con_data, cd) => (
                                                      <>
                                                        <br />
                                                        {con_data.name} -{" "}
                                                        {con_data.mobile_no}
                                                      </>
                                                    ),
                                                  )
                                                : ""}
                                              {`${
                                                cus.tracking_note === null
                                                  ? ""
                                                  : cus.tracking_note
                                              }`}
                                            </Tooltip>
                                          }
                                        >
                                          <Button
                                            simple
                                            bsStyle="info"
                                            bsSize="xs"
                                          >
                                            <i class="fa fa-info-circle" />
                                          </Button>
                                        </OverlayTrigger>
                                        {cus.order_status != "4" &&
                                        this.checkIsEligibleToShowOrderButton(
                                          cus.riderdetails,
                                          cus.paymentoption,
                                          cus.payment_status,
                                        ) &&
                                        (this.state.store === 1 ||
                                          this.state.store === null) ? (
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={payment}
                                          >
                                            <Button
                                              simple
                                              bsStyle="info"
                                              bsSize="xs"
                                              onClick={this.paymentdetail.bind(
                                                this,
                                                cus.id,
                                                cus.total_cost,
                                                cus.paid_amount,
                                                cus.order_status,
                                                cus.status_label,
                                              )}
                                            >
                                              <i class="fa fa-check-square-o" />
                                            </Button>
                                          </OverlayTrigger>
                                        ) : (
                                          ""
                                        )}
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={edit}
                                        >
                                          <Button
                                            style={{ display: "none" }}
                                            simple
                                            bsStyle="success"
                                            onClick={this.editOrder.bind(
                                              this,
                                              cus.id,
                                              cus.channel,
                                              cus.order_sub_type,
                                            )}
                                            bsSize="xs"
                                          >
                                            <i className="fa fa-pencil" />
                                          </Button>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={edit}
                                        >
                                          <Button
                                            simple
                                            bsStyle="success"
                                            onClick={this.editOrderNew.bind(
                                              this,
                                              cus.id,
                                              cus.channel,
                                              cus.order_sub_type,
                                            )}
                                            bsSize="xs"
                                          >
                                            <i className="fa fa-pencil" />
                                          </Button>
                                        </OverlayTrigger>
                                        {[3, 4, 8, 11, 19].includes(
                                          Number(cus.order_status),
                                        ) && (
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={cancelModal}
                                          >
                                            <Button
                                              simple
                                              bsStyle="danger"
                                              onClick={this.cancellationOrder.bind(
                                                this,
                                                cus.id,
                                              )}
                                              bsSize="xs"
                                            >
                                              <i className="fa fa-window-close" />
                                            </Button>
                                          </OverlayTrigger>
                                        )}
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={replicate}
                                        >
                                          <Button
                                            simple
                                            bsStyle="success"
                                            onClick={this.replicateOrder.bind(
                                              this,
                                              cus.id,
                                              cus.channel,
                                            )}
                                            bsSize="xs"
                                          >
                                            <i className="fa fa-copy" />
                                          </Button>
                                        </OverlayTrigger>
                                        {cus.is_insureme && (
                                          <>
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={claimConfirmation}
                                            >
                                              <Button
                                                simple
                                                bsStyle="info"
                                                onClick={() =>
                                                  this.claimConfirmation(cus.id)
                                                }
                                                bsSize="xs"
                                              >
                                                <i className="	fa fa-creative-commons" />
                                              </Button>
                                            </OverlayTrigger>
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={insuremeDocumentUpload}
                                            >
                                              <Button
                                                simple
                                                bsStyle="info"
                                                onClick={() =>
                                                  this.uploadDocumentConfirmation(
                                                    cus.prescriptiondata,
                                                  )
                                                }
                                                bsSize="xs"
                                              >
                                                <i className="fa fa-cloud-upload" />
                                              </Button>
                                            </OverlayTrigger>
                                          </>
                                        )}

                                        {cus.order_status != "4" &&
                                        cus.order_status != "11" &&
                                        cus.order_status != "2" &&
                                        cus.order_status != "13" &&
                                        cus.order_status != "9" &&
                                        cus.order_status != "14" ? (
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={completeOrderOnGo}
                                          >
                                            <Button
                                              simple
                                              bsStyle="success"
                                              onClick={this.handleCompleteOrderOneClick.bind(
                                                this,
                                                cus.id,
                                              )}
                                              bsSize="xs"
                                            >
                                              <i className="fas fa-retweet	" />
                                            </Button>
                                          </OverlayTrigger>
                                        ) : (
                                          ""
                                        )}
                                        {this.state.useraccess == 1 && (
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={remove}
                                          >
                                            <Button
                                              simple
                                              bsStyle="danger"
                                              onClick={this.warningWithConfirmAndCancelMessage.bind(
                                                this,
                                                cus.id,
                                              )}
                                              bsSize="xs"
                                            >
                                              <i className="fa fa-times" />
                                            </Button>
                                          </OverlayTrigger>
                                        )}
                                        {this.state.store !== 1 &&
                                          this.state.store !== null &&
                                          cus.order_status == 1 && (
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={token}
                                            >
                                              <Button
                                                simple
                                                bsStyle="info"
                                                onClick={this.handleCreateToken.bind(
                                                  this,
                                                  cus.id,
                                                )}
                                                bsSize="xs"
                                              >
                                                <i className="fa fa-print" />
                                              </Button>
                                            </OverlayTrigger>
                                          )}
                                      </td>
                                    </tr>
                                  ))}
                                </React.Fragment>
                              )}
                            </tbody>
                          </Table>
                          {/* Disply Card View */}
                          {order_data.map((cus) => (
                            <div
                              className={`card-container ${
                                cus.is_viewed_by_admin === "0" ||
                                (cus.source === 8 && cus.order_status === 1)
                                  ? "red_background"
                                  : ""
                              }`}
                              key={cus.id}
                            >
                              <input
                                type="checkbox"
                                onClick={this.handleAllChecked}
                                value="checkedall"
                              />
                              &nbsp;Select All
                              <div
                                className="card"
                                style={{
                                  boxShadow:
                                    "rgba(6, 24, 44, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset",
                                }}
                              >
                                <div className="card-item">
                                  <span className="card-item-label">
                                    <input
                                      type="checkbox"
                                      onClick={this.handleCheckChieldElement}
                                      checked={cus.isChecked}
                                      value={cus.id}
                                      disabled={cus.isDisabled}
                                    />
                                  </span>
                                  <span className="card-item-value"></span>
                                </div>
                                <div className="card-item">
                                  <span className="card-item-label">#Id</span>
                                  <span className="card-item-value">
                                    {cus.id}{" "}
                                    {cus.channel == "app" ? (
                                      <i
                                        className="fa fa-mobile"
                                        style={{ fontSize: "25px" }}
                                      ></i>
                                    ) : cus.channel == "web" ? (
                                      <i
                                        className="fa fa-desktop"
                                        style={{ fontSize: "17px" }}
                                      ></i>
                                    ) : (
                                      ""
                                    )}
                                    {cus.channel == "flash_consult" ? (
                                      <i
                                        className="fa fa-user"
                                        style={{ fontSize: "25px" }}
                                      ></i>
                                    ) : (
                                      ""
                                    )}
                                  </span>
                                </div>
                                <div className="card-item">
                                  <span className="card-item-label">
                                    Subscriber:
                                  </span>
                                  <span className="card-item-value">
                                    {cus.lead.name.toLowerCase()}
                                  </span>
                                </div>
                                <div className="card-item">
                                  <span className="card-item-label">
                                    Order Date:
                                  </span>
                                  <span className="card-item-value">
                                    {this.handlrTimeZone(
                                      cus.order_display_date,
                                    )}
                                  </span>
                                </div>
                                <div className="card-item">
                                  <span className="card-item-label">
                                    Total Cost:
                                  </span>
                                  <span className="card-item-value">
                                    {(cus.total_cost - 0).toFixed(2)}
                                  </span>
                                </div>
                                <div className="card-item">
                                  <span className="card-item-label">
                                    Source:
                                  </span>
                                  <span className="card-item-value">
                                    {order_source_arr[cus.source]}
                                  </span>
                                </div>
                                <div className="card-item">
                                  <span className="card-item-label">
                                    Status:
                                  </span>
                                  <span className="card-item-value">
                                    {cus.order_status == 1 ||
                                    cus.order_status == 2 ? (
                                      <td
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <p
                                          className="btn btn-fill "
                                          style={{
                                            backgroundColor:
                                              cus.order_status == 1
                                                ? "#FFA823"
                                                : cus.order_status == 2
                                                  ? "#A91079"
                                                  : "",
                                            border:
                                              cus.order_status == 1
                                                ? "none"
                                                : cus.order_status == 2
                                                  ? "none"
                                                  : "",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "block",
                                              fontSize: "10px",
                                            }}
                                          >
                                            {order_status_arr[cus.order_status]}
                                          </span>
                                          {cus.order_status == 2 &&
                                          cus.process_start_time !== null ? (
                                            <span
                                              style={{
                                                display: "block",
                                                fontSize: "8px",
                                              }}
                                            >
                                              {moment(
                                                cus.process_start_time,
                                              ).format("YYYY/MM/DD HH:mm:ss")}
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </p>
                                        {cus.order_status == 2 &&
                                        moment(new Date()).diff(
                                          moment(
                                            new Date(cus.process_start_time),
                                          ),
                                          "days",
                                        ) >= 3 ? (
                                          <i>
                                            <img
                                              style={{ marginLeft: "10px" }}
                                              src="https://s3.ap-south-1.amazonaws.com/admin-dev.flash.health/red-alert-icon.svg"
                                              width="25px"
                                              height="25px"
                                            />
                                          </i>
                                        ) : (
                                          ""
                                        )}
                                        {cus.order_status == 1 &&
                                        cus.order_sub_type === 1 &&
                                        moment(new Date()).diff(
                                          moment(new Date(cus.created_at)),
                                          "minute",
                                        ) > 20 ? (
                                          <i>
                                            <img
                                              style={{ marginLeft: "10px" }}
                                              src="https://s3.ap-south-1.amazonaws.com/admin-dev.flash.health/red-alert-icon.svg"
                                              width="25px"
                                              height="25px"
                                            />
                                          </i>
                                        ) : (
                                          ""
                                        )}
                                        {cus.is_claimable === "1" && (
                                          <i
                                            style={{
                                              fontSize: "14px",
                                              background: "red",
                                              color: "white",
                                              borderRadius: "5px",
                                              margin: "5px",
                                              paddingLeft: "5px",
                                              paddingRight: "5px",
                                            }}
                                          >
                                            CLAIM
                                          </i>
                                        )}
                                      </td>
                                    ) : cus.order_status == 3 ? (
                                      <td className="">
                                        <p className="btn btn-fill fl_text_navyBlue ">
                                          {" "}
                                          <span
                                            style={{
                                              display: "block",
                                              fontSize: "10px",
                                            }}
                                          >
                                            {order_status_arr[cus.order_status]}
                                          </span>
                                          {cus.order_status == 3 &&
                                          cus.dispatch_start_time !== null ? (
                                            <span
                                              style={{
                                                display: "block",
                                                fontSize: "8px",
                                              }}
                                            >
                                              {moment(
                                                cus.dispatch_start_time,
                                              ).format("YYYY/MM/DD HH:mm:ss")}
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </p>
                                        {cus.is_claimable === "1" && (
                                          <i
                                            style={{
                                              fontSize: "14px",
                                              background: "red",
                                              color: "white",
                                              borderRadius: "5px",
                                              margin: "5px",
                                              paddingLeft: "5px",
                                              paddingRight: "5px",
                                            }}
                                          >
                                            CLAIM
                                          </i>
                                        )}
                                      </td>
                                    ) : cus.order_status == 4 ? (
                                      <td className="">
                                        <p className="btn btn-fill fl_text_green ">
                                          {" "}
                                          <span
                                            style={{
                                              display: "block",
                                              fontSize: "10px",
                                            }}
                                          >
                                            {order_status_arr[cus.order_status]}
                                          </span>
                                          {cus.completed_time !== null ? (
                                            <span
                                              style={{
                                                display: "block",
                                                fontSize: "8px",
                                              }}
                                            >
                                              {moment(
                                                cus.completed_time,
                                              ).format("YYYY/MM/DD HH:mm:ss")}
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </p>
                                        {cus.is_claimable === "1" && (
                                          <i
                                            style={{
                                              fontSize: "14px",
                                              background: "red",
                                              color: "white",
                                              borderRadius: "5px",
                                              margin: "5px",
                                              paddingLeft: "5px",
                                              paddingRight: "5px",
                                            }}
                                          >
                                            CLAIM
                                          </i>
                                        )}
                                      </td>
                                    ) : cus.order_status == 5 ||
                                      cus.order_status == 8 ? (
                                      <td
                                        style={{ display: "inline-flex" }}
                                        className=""
                                      >
                                        <p className="btn btn-fill fl_text_red">
                                          <span
                                            style={{
                                              display: "block",
                                              fontSize: "10px",
                                            }}
                                          >
                                            {order_status_arr[cus.order_status]}
                                          </span>
                                          {cus.order_status == 8 &&
                                          cus.payment_pending_start_time !==
                                            null ? (
                                            <span
                                              style={{
                                                display: "block",
                                                fontSize: "8px",
                                              }}
                                            >
                                              {moment(
                                                cus.payment_pending_start_time,
                                              ).format("YYYY/MM/DD HH:mm:ss")}
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </p>
                                        {cus.order_status == "5" ? (
                                          <i
                                            className="fa fa-ban"
                                            onClick={this.open_cancel_reason_display_Modal.bind(
                                              this,
                                              cus.cancel_reason,
                                              cus.cancel_message,
                                            )}
                                            title="Show Order Cancel reason "
                                          ></i>
                                        ) : (
                                          ""
                                        )}
                                        {cus.is_claimable === "1" && (
                                          <i
                                            style={{
                                              fontSize: "14px",
                                              background: "red",
                                              color: "white",
                                              borderRadius: "5px",
                                              margin: "5px",
                                              paddingLeft: "5px",
                                              paddingRight: "5px",
                                            }}
                                          >
                                            CLAIM
                                          </i>
                                        )}
                                      </td>
                                    ) : cus.order_status == 9 ? (
                                      <td
                                        style={{ display: "inline-flex" }}
                                        className=""
                                      >
                                        <p className="btn btn-fill ">
                                          <span
                                            style={{
                                              display: "block",
                                              fontSize: "10px",
                                            }}
                                          >
                                            {order_status_arr[cus.order_status]}
                                          </span>
                                        </p>
                                        {cus.order_status == "9" ? (
                                          <a
                                            className="fa fa-eye"
                                            href={cus.short_url}
                                            target="_blank"
                                            title="Submit Quote"
                                          ></a>
                                        ) : (
                                          ""
                                        )}
                                        {cus.is_claimable === "1" && (
                                          <i
                                            style={{
                                              fontSize: "14px",
                                              background: "red",
                                              color: "white",
                                              borderRadius: "5px",
                                              margin: "5px",
                                              paddingLeft: "5px",
                                              paddingRight: "5px",
                                            }}
                                          >
                                            CLAIM
                                          </i>
                                        )}
                                      </td>
                                    ) : cus.order_status == 12 ? (
                                      <td className="">
                                        <p className="btn btn-fill fl_text_purple">
                                          <span
                                            style={{
                                              display: "block",
                                              fontSize: "10px",
                                            }}
                                          >
                                            {order_status_arr[cus.order_status]}
                                          </span>
                                        </p>
                                        {cus.is_claimable === "1" && (
                                          <i
                                            style={{
                                              fontSize: "14px",
                                              background: "red",
                                              color: "white",
                                              borderRadius: "5px",
                                              margin: "5px",
                                              paddingLeft: "5px",
                                              paddingRight: "5px",
                                            }}
                                          >
                                            CLAIM
                                          </i>
                                        )}
                                      </td>
                                    ) : cus.order_status == 14 ? (
                                      <td className="">
                                        <p className="btn btn-fill fl_text_blue">
                                          <span
                                            style={{
                                              display: "block",
                                              fontSize: "10px",
                                            }}
                                          >
                                            {order_status_arr[cus.order_status]}
                                          </span>
                                        </p>
                                        {cus.is_claimable === "1" && (
                                          <i
                                            style={{
                                              fontSize: "14px",
                                              background: "red",
                                              color: "white",
                                              borderRadius: "5px",
                                              margin: "5px",
                                              paddingLeft: "5px",
                                              paddingRight: "5px",
                                            }}
                                          >
                                            CLAIM
                                          </i>
                                        )}
                                      </td>
                                    ) : cus.order_status == 10 ? (
                                      <td className="">
                                        <p className="btn btn-fill fl_text_review">
                                          <span
                                            style={{
                                              display: "block",
                                              fontSize: "10px",
                                            }}
                                          >
                                            {order_status_arr[cus.order_status]}
                                          </span>
                                        </p>
                                        {cus.is_claimable === "1" && (
                                          <i
                                            style={{
                                              fontSize: "14px",
                                              background: "red",
                                              color: "white",
                                              borderRadius: "5px",
                                              margin: "5px",
                                              paddingLeft: "5px",
                                              paddingRight: "5px",
                                            }}
                                          >
                                            CLAIM
                                          </i>
                                        )}
                                      </td>
                                    ) : (
                                      <td className="">
                                        <p
                                          className="btn btn-fill"
                                          style={{
                                            backgroundColor:
                                              cus.order_status == 11
                                                ? "#5C3D2E"
                                                : cus.order_status == 13
                                                  ? "black"
                                                  : "",
                                            border:
                                              cus.order_status == 11
                                                ? "none"
                                                : cus.order_status == 13
                                                  ? "none"
                                                  : "",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "block",
                                              fontSize: "10px",
                                            }}
                                          >
                                            {order_status_arr[cus.order_status]}
                                          </span>
                                          {cus.order_status == 11 &&
                                          cus.packed_start_time !== null ? (
                                            <span
                                              style={{
                                                display: "block",
                                                fontSize: "8px",
                                              }}
                                            >
                                              {moment(
                                                cus.packed_start_time,
                                              ).format("YYYY/MM/DD HH:mm:ss")}
                                            </span>
                                          ) : cus.order_status == 13 &&
                                            cus.draft_start_time !== null ? (
                                            <span
                                              style={{
                                                display: "block",
                                                fontSize: "8px",
                                              }}
                                            >
                                              {moment(
                                                cus.draft_start_time,
                                              ).format("YYYY/MM/DD HH:mm:ss")}
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </p>
                                        {cus.is_claimable === "1" && (
                                          <i
                                            style={{
                                              fontSize: "14px",
                                              background: "red",
                                              color: "white",
                                              borderRadius: "5px",
                                              margin: "5px",
                                              paddingLeft: "5px",
                                              paddingRight: "5px",
                                            }}
                                          >
                                            CLAIM
                                          </i>
                                        )}
                                      </td>
                                    )}
                                  </span>
                                </div>
                                <div className="card-item">
                                  <span className="card-item-label">
                                    Rider Name:
                                  </span>
                                  <span className="card-item-value">
                                    {cus.rider_id != null
                                      ? cus.riderdetails != null
                                        ? cus.riderdetails.name
                                        : ""
                                      : ""}
                                  </span>
                                </div>
                                <div className="card-item">
                                  <span className="card-item-label">
                                    Pending Amount:
                                  </span>
                                  <span className="card-item-value">
                                    {" "}
                                    {cus.total_cost == "0" ? (
                                      <td>
                                        {cus.order_status != "4"
                                          ? (cus.total_cost - 0).toFixed(2)
                                          : "-"}
                                      </td>
                                    ) : (
                                      <td>
                                        {cus.order_status != "4"
                                          ? (
                                              cus.total_cost - cus.paid_amount
                                            ).toFixed(2)
                                          : "-"}
                                      </td>
                                    )}
                                  </span>
                                </div>
                                <div className="card-item">
                                  <span className="card-item-label">
                                    Payment Type:
                                  </span>
                                  <span className="card-item-value">
                                    {cus.paymentoption}
                                  </span>
                                </div>
                                <div className="card-item">
                                  <span className="card-item-label">
                                    Pending Status:
                                  </span>
                                  <span className="card-item-value">
                                    {cus.payment_status}
                                  </span>
                                </div>
                                <div className="card-item">
                                  <span className="card-item-label">
                                    Invoice:
                                  </span>
                                  <span className="card-item-value">
                                    {" "}
                                    <Button
                                      disabled={!this.state.processing}
                                      onClick={this.downloadinvoice.bind(
                                        this,
                                        cus.id,
                                      )}
                                    >
                                      View
                                    </Button>
                                  </span>
                                </div>
                                <div className="card-item">
                                  <span className="card-item-label">
                                    Actions:
                                  </span>
                                  <span className="card-item-value">
                                    {cus.payment_status == "failed" &&
                                      cus.channel == "app" &&
                                      cus.paymentoption == "Card" &&
                                      cus.source == 1 && (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={charge}
                                        >
                                          <Button
                                            simple
                                            disabled={
                                              this.state.chargeProcessing
                                            }
                                            bsStyle="success"
                                            // bsSize="xs"
                                            onClick={this.warningWithChargeMessage.bind(
                                              this,
                                              cus.id,
                                            )}
                                          >
                                            <i class="fa fa-address-card" />
                                          </Button>
                                        </OverlayTrigger>
                                      )}
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={notification}
                                    >
                                      <Button
                                        simple
                                        bsStyle="info"
                                        // bsSize="xs"
                                        onClick={this.sendNotification.bind(
                                          this,
                                          cus.id,
                                          cus.total_cost,
                                          cus.paid_amount,
                                          cus.order_status,
                                        )}
                                      >
                                        <i class="fa  fa-bell"></i>
                                      </Button>
                                    </OverlayTrigger>
                                    {cus.doner_id != null ? (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id="button-tooltip">
                                            {cus.doner ? (
                                              <>
                                                {cus.doner.name ? (
                                                  <>
                                                    {cus.doner.name}
                                                    <br />
                                                  </>
                                                ) : (
                                                  ""
                                                )}
                                                {cus.doner.mobile_no ? (
                                                  <>
                                                    {cus.doner.mobile_no}
                                                    <br />
                                                  </>
                                                ) : (
                                                  ""
                                                )}
                                              </>
                                            ) : (
                                              ""
                                            )}
                                          </Tooltip>
                                        }
                                      >
                                        <Button
                                          simple
                                          bsStyle="info"
                                          // bsSize="xs"
                                        >
                                          <i
                                            style={{ color: "orange" }}
                                            class="fa fa-heartbeat"
                                            aria-hidden="true"
                                          ></i>
                                        </Button>
                                      </OverlayTrigger>
                                    ) : (
                                      ""
                                    )}
                                    <OverlayTrigger
                                      placement="top"
                                      trigger="focus"
                                      onEntered={() => this.getb2bdata(cus)}
                                      overlay={
                                        <Tooltip id="button-tooltip">
                                          {`${cus.lead.mobile_no}`}
                                          <br />
                                          {`${cus.address.address_line1}`}{" "}
                                          {cus.address.address_line2 != null
                                            ? cus.address.address_line2
                                            : ""}
                                          <br /> <b>Delivery Type</b> :
                                          {cus.delivery_type == 1
                                            ? "Normal"
                                            : "Express"}
                                          {cus.tracking_id === null ? null : (
                                            <>
                                              <br /> <b>Tracking_ID :</b>
                                            </>
                                          )}{" "}
                                          {`${
                                            cus.tracking_id === null
                                              ? ""
                                              : cus.tracking_id
                                          }`}
                                          {cus.tracking_id === null ? null : (
                                            <>
                                              <br /> <b>Tracking_URL :</b>
                                            </>
                                          )}{" "}
                                          {`${
                                            cus.tracking_url === null
                                              ? ""
                                              : cus.tracking_url
                                          }`}
                                          {cus.tracking_id === null ? null : (
                                            <>
                                              <br /> <b>Tracking_Note :</b>
                                            </>
                                          )}{" "}
                                          {this.state.order_b2bcontact_details
                                            .length > 0
                                            ? this.state.order_b2bcontact_details.map(
                                                (con_data, cd) => (
                                                  <>
                                                    <br />
                                                    {con_data.name} -{" "}
                                                    {con_data.mobile_no}
                                                  </>
                                                ),
                                              )
                                            : ""}
                                          {`${
                                            cus.tracking_note === null
                                              ? ""
                                              : cus.tracking_note
                                          }`}
                                        </Tooltip>
                                      }
                                    >
                                      <Button
                                        simple
                                        bsStyle="info"
                                        // bsSize="xs"
                                      >
                                        <i class="fa fa-info-circle" />
                                      </Button>
                                    </OverlayTrigger>
                                    {cus.order_status != "4" ? (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={payment}
                                      >
                                        <Button
                                          simple
                                          bsStyle="info"
                                          // bsSize="xs"
                                          onClick={this.paymentdetail.bind(
                                            this,
                                            cus.id,
                                            cus.total_cost,
                                            cus.paid_amount,
                                            cus.order_status,
                                            cus.status_label,
                                          )}
                                        >
                                          <i class="fa fa-check-square-o" />
                                        </Button>
                                      </OverlayTrigger>
                                    ) : (
                                      ""
                                    )}
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={edit}
                                    >
                                      <Button
                                        simple
                                        bsStyle="success"
                                        onClick={this.editOrder.bind(
                                          this,
                                          cus.id,
                                          cus.channel,
                                        )}
                                        // bsSize="xs"
                                      >
                                        <i className="fa fa-pencil" />
                                      </Button>
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={replicate}
                                    >
                                      <Button
                                        simple
                                        bsStyle="success"
                                        onClick={this.replicateOrder.bind(
                                          this,
                                          cus.id,
                                          cus.channel,
                                        )}
                                        // bsSize="xs"
                                      >
                                        <i className="fa fa-copy" />
                                      </Button>
                                    </OverlayTrigger>
                                    {cus.order_status != "4" &&
                                    cus.order_status != "11" &&
                                    cus.order_status != "2" &&
                                    cus.order_status != "13" &&
                                    cus.order_status != "9" &&
                                    cus.order_status != "14" ? (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={completeOrderOnGo}
                                      >
                                        <Button
                                          simple
                                          bsStyle="success"
                                          onClick={this.handleCompleteOrderOneClick.bind(
                                            this,
                                            cus.id,
                                          )}
                                          // bsSize="xs"
                                        >
                                          <i className="fas fa-retweet	" />
                                        </Button>
                                      </OverlayTrigger>
                                    ) : (
                                      ""
                                    )}
                                    {this.state.useraccess == 1 && (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={remove}
                                      >
                                        <Button
                                          simple
                                          bsStyle="danger"
                                          onClick={this.warningWithConfirmAndCancelMessage.bind(
                                            this,
                                            cus.id,
                                          )}
                                          // bsSize="xs"
                                        >
                                          <i className="fa fa-times" />
                                        </Button>
                                      </OverlayTrigger>
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          ))}

                          {this.state.loading ? (
                            ""
                          ) : this.state.noRecordFound ? (
                            ""
                          ) : (
                            <div style={{ textAlign: "center" }}>
                              <Pagination>
                                {this.state.current > 0 && (
                                  <Pagination.First
                                    onClick={() =>
                                      this.setState({
                                        current: this.state.current - 1,
                                      })
                                    }
                                  >
                                    &lt;&lt;&lt;
                                  </Pagination.First>
                                )}

                                {this.state.paginationData
                                  .slice(
                                    this.state.current * this.state.pageSize,
                                    (this.state.current + 1) *
                                      this.state.pageSize,
                                  )
                                  .map((url, index) => {
                                    const pageNumber =
                                      this.state.current * this.state.pageSize +
                                      index +
                                      1;

                                    return (
                                      <Pagination.Item
                                        key={pageNumber}
                                        active={
                                          this.state.currentPage === pageNumber
                                        }
                                        onClick={() => {
                                          this.setState({
                                            currentPage: pageNumber,
                                          });
                                          this.getdata(url);
                                        }}
                                      >
                                        {pageNumber}
                                      </Pagination.Item>
                                    );
                                  })}

                                {(this.state.current + 1) *
                                  this.state.pageSize <
                                  this.state.paginationData.length && (
                                  <Pagination.Last
                                    onClick={() =>
                                      this.setState({
                                        current: this.state.current + 1,
                                      })
                                    }
                                  >
                                    &gt;&gt;&gt;
                                  </Pagination.Last>
                                )}
                              </Pagination>
                            </div>
                          )}
                        </Col>
                        <Modal
                          show={this.state.show_charge_message}
                          onHide={() =>
                            this.setState({ show_charge_message: true })
                          }
                        >
                          <Modal.Body>
                            <p> {this.state.charge_message} </p>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              bsStyle="success"
                              fill
                              onClick={() =>
                                this.setState({ show_charge_message: false })
                              }
                            >
                              OK
                            </Button>
                          </Modal.Footer>
                        </Modal>
                        <Modal
                          show={this.state.showpaymentdetailmodal}
                          onHide={() =>
                            this.setState({
                              showpaymentdetailmodal: false,
                              errormessages: [],
                            })
                          }
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>Payment Details</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <form>
                              {errormessages.length != 0 && (
                                <div className=" alert alert-danger">
                                  {errormessages.map((data) => (
                                    <React.Fragment>
                                      <li>{data}</li>
                                    </React.Fragment>
                                  ))}
                                </div>
                              )}
                              <FormGroup className="order_source_data">
                                <ControlLabel>Payment type</ControlLabel>
                                &nbsp;
                                <Radio
                                  number="5"
                                  option="1"
                                  name="paymenttype"
                                  onChange={this.onpaymentchange}
                                  checked={this.state.paymenttype === "1"}
                                  label="Paid in full"
                                />
                                &nbsp;
                                <Radio
                                  number="6"
                                  option="2"
                                  name="paymenttype"
                                  onChange={this.onpaymentchange}
                                  checked={this.state.paymenttype === "2"}
                                  label="Partial Payment"
                                />
                              </FormGroup>
                              {this.state.paymenttype == "2" ? (
                                <>
                                  {this.state.p_paid_amount != null &&
                                  this.state.paymenttype == "2" ? (
                                    <p>
                                      Paid Amount :{" "}
                                      <b>
                                        {" "}
                                        {(this.state.p_paid_amount - 0).toFixed(
                                          2,
                                        )}{" "}
                                      </b>{" "}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                  {this.state.remainpaymentamount != "0" &&
                                  this.state.paymenttype == "2" ? (
                                    <p>
                                      {" "}
                                      Pending Amount :{" "}
                                      <b>
                                        {" "}
                                        {(
                                          this.state.remainpaymentamount - 0
                                        ).toFixed(2)}{" "}
                                      </b>{" "}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                  {this.state.p_total_cost != "0" &&
                                  this.state.paymenttype == "2" ? (
                                    <p>
                                      {" "}
                                      Total Amount :{" "}
                                      <b>
                                        {" "}
                                        {(this.state.p_total_cost - 0).toFixed(
                                          2,
                                        )}{" "}
                                      </b>{" "}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                  <FormGroup>
                                    <ControlLabel>Amount</ControlLabel>
                                    <FormControl
                                      type="number"
                                      min={0}
                                      value={this.state.paidamount}
                                      onChange={this.onpaymentchange}
                                      name="paidamount"
                                      placeholder="0.00"
                                    ></FormControl>
                                  </FormGroup>
                                </>
                              ) : (
                                ""
                              )}
                            </form>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              bsStyle="danger"
                              fill
                              onClick={this.closepaymentdetailmodal.bind(this)}
                            >
                              Close
                            </Button>
                            <Button
                              bsStyle="success"
                              fill
                              onClick={this.submitpaymentdetail.bind(this)}
                            >
                              Submit
                            </Button>
                          </Modal.Footer>
                        </Modal>
                        <Modal
                          show={this.state.shownotificationmodal}
                          onHide={() =>
                            this.setState({ shownotificationmodal: true })
                          }
                        >
                          <Modal.Header>
                            <Modal.Title>
                              Send Push Notification / SMS
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <p>
                              <FormGroup className="order_source_data">
                                <ControlLabel>Notification type</ControlLabel>
                                &nbsp; &nbsp;
                                <Radio
                                  number="11"
                                  option="delay"
                                  name="notificationtype"
                                  onChange={this.onnotificationchange}
                                  checked={
                                    this.state.notificationtype === "delay"
                                  }
                                  label="Order delay"
                                />
                                &nbsp;
                                <Radio
                                  number="12"
                                  option="reminder"
                                  name="notificationtype"
                                  onChange={this.onnotificationchange}
                                  checked={
                                    this.state.notificationtype === "reminder"
                                  }
                                  label="Payment Reminder"
                                />
                                &nbsp;
                                {this.state.status == 13 ? (
                                  <Radio
                                    number="13"
                                    option="quotation"
                                    name="notificationtype"
                                    onChange={this.onnotificationchange}
                                    checked={
                                      this.state.notificationtype ===
                                      "quotation"
                                    }
                                    label="B2B Quotation"
                                  />
                                ) : (
                                  ""
                                )}
                              </FormGroup>

                              {this.state.status == 13 &&
                              this.state.notificationtype === "quotation" ? (
                                <FormGroup className="order_source_data">
                                  <Row>
                                    <Col
                                      sm={4}
                                      md={4}
                                      xs={4}
                                      style={{ marginBottom: "20px" }}
                                    >
                                      <FormGroup>
                                        <ControlLabel
                                          style={{ marginLeft: "30px" }}
                                        >
                                          Email
                                        </ControlLabel>
                                        &nbsp;&nbsp;
                                        <EmailMultiValueTextInput
                                          textFields={b2bEmail}
                                          handleMultiTextField={(val) =>
                                            this.handleMultiTextField(val)
                                          }
                                        />
                                      </FormGroup>
                                      <ControlLabel
                                        style={{ marginLeft: "30px" }}
                                      >
                                        Validity Date
                                      </ControlLabel>
                                      &nbsp;&nbsp;
                                      <Datetime
                                        timeFormat={false}
                                        dateFormat="YYYY-MM-DD"
                                        inputProps={{
                                          placeholder: "Validity Date",
                                        }}
                                        closeOnSelect={true}
                                        value={this.state.validityDate}
                                        onChange={this.handleValidityDateChange}
                                        isValidDate={this.valid}
                                        className="DateTime"
                                      />
                                    </Col>
                                  </Row>
                                </FormGroup>
                              ) : (
                                ""
                              )}
                            </p>
                          </Modal.Body>
                          <Modal.Footer>
                            {this.state.notificationtype != "quotation" ? (
                              <Button
                                onClick={this.warningWithSendNotification.bind(
                                  this,
                                )}
                                bsStyle="success"
                                fill
                              >
                                Send Notification
                              </Button>
                            ) : (
                              ""
                            )}
                            &nbsp;
                            {this.state.notificationtype === "quotation" ? (
                              <Button
                                onClick={this.warningWithSendB2bNotification.bind(
                                  this,
                                  this.state.p_orderid,
                                  this.state.b2bEmail,
                                  this.state.validityDate,
                                )}
                                bsStyle="success"
                                fill
                              >
                                Send Email
                              </Button>
                            ) : (
                              ""
                            )}
                            &nbsp;
                            <Button
                              bsStyle="danger"
                              fill
                              onClick={this.closeNotificationmodal.bind(this)}
                            >
                              Cancel
                            </Button>
                            {this.state.validityDateError}
                          </Modal.Footer>
                        </Modal>
                        <Modal
                          show={this.state.showSmsMessageModal}
                          onHide={() =>
                            this.setState({ showSmsMessageModal: true })
                          }
                        >
                          <Modal.Body>
                            <p> {this.state.smsMessage} </p>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              bsStyle="success"
                              fill
                              onClick={() =>
                                this.setState({ showSmsMessageModal: false })
                              }
                            >
                              OK
                            </Button>
                          </Modal.Footer>
                        </Modal>
                        <Modal
                          show={this.state.cancel_reason_display_Modal}
                          onHide={() =>
                            this.setState({ cancel_reason_display_Modal: true })
                          }
                        >
                          <Modal.Header>
                            <Modal.Title>Order Cancel</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <p>
                              Cancel Reason : {this.state.Cancel_reason_state}{" "}
                              <br></br>
                              Cancel Message :{" "}
                              {this.state.Cancel_message_state}{" "}
                            </p>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              bsStyle="danger"
                              fill
                              onClick={this.close_cancel_reason_display_Modal.bind(
                                this,
                              )}
                            >
                              Cancel
                            </Button>
                          </Modal.Footer>
                        </Modal>
                        <Modal
                          show={this.state.cancelorderModal}
                          onHide={() =>
                            this.setState({ cancelorderModal: true })
                          }
                        >
                          <Modal.Header>
                            <Modal.Title>
                              {this.state.cancelModalTitle}
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <FormGroup>
                              <ControlLabel>
                                {this.state.cancelModalLabel}
                              </ControlLabel>
                              {/* <FormControl
                                type="text"
                                value={this.state.ordercancelreason}
                                onChange={this.oncancelchnage}
                                name="ordercancelreason"
                                placeholder="Cancel Reason"
                              ></FormControl> */}

                              <select
                                onChange={this.oncancelchnage}
                                name="ordercancelreason"
                                value={this.state.ordercancelreason}
                                className="form-control"
                              >
                                <option value="">Select Cancel Reason</option>
                                <option value="Item not available anywhere in the island">
                                  Item not available anywhere in the island
                                </option>
                                <option value="Delivery price too high">
                                  Delivery price too high
                                </option>
                                <option value="Delay in order delivery">
                                  Delay in order delivery
                                </option>
                                <option value="Item too expensive">
                                  Item too expensive
                                </option>
                                <option value="This is a test order">
                                  This is a test order
                                </option>
                                <option value="Placed order by mistake">
                                  Placed order by mistake
                                </option>
                                <option value="The prescription is expired or not valid">
                                  The prescription is expired or not valid
                                </option>
                                <option value="This is an abusable drug - no/invalid prescription">
                                  This is an abusable drug - no/invalid
                                  prescription
                                </option>
                                <option value="Order cancelled by promtxp">
                                  Order cancelled by promtxp
                                </option>
                                <option value="Customer unreachable">
                                  Customer unreachable
                                </option>
                                <option value="Customer has placed order twice">
                                  Customer has placed order twice
                                </option>
                                <option value="Customer is not agreeing for a bank transfer">
                                  Customer is not agreeing for a bank transfer
                                </option>
                                <option value="Because of temperature control medicine">
                                  Because of temperature control medicine
                                </option>
                                <option value="Payment delay">
                                  Payment delay
                                </option>
                                <option value=" Prescription Not available / Not Valid">
                                  Prescription Not available / Not Valid
                                </option>
                                <option value="Other">Other</option>
                              </select>

                              {this.state.ordercancelreasonError}
                            </FormGroup>
                            {this.state.ordercancelreason === "Other" && (
                              <>
                                <FormGroup>
                                  <ControlLabel>Reason</ControlLabel>
                                  <textarea
                                    name="reason"
                                    className="form-control"
                                    rows="3"
                                    value={this.state.cancel_message}
                                    onChange={(event) => {
                                      this.setState({
                                        cancel_message: event.target.value,
                                      });
                                    }}
                                    placeholder="Enter Reason"
                                  ></textarea>
                                </FormGroup>
                              </>
                            )}
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              onClick={this.submitCancelOrderModal.bind(this)}
                              bsStyle="success"
                              fill
                            >
                              Submit
                            </Button>
                            &nbsp;
                            <Button
                              onClick={this.closeCancelOrderModal.bind(this)}
                              bsStyle="info"
                              fill
                            >
                              Close
                            </Button>
                          </Modal.Footer>
                        </Modal>

                        <Modal
                          show={this.state.supplierModal}
                          onHide={() => this.setState({ supplierModal: true })}
                        >
                          <Modal.Header>
                            <Modal.Title>Waiting for supplier</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <FormGroup>
                              <ControlLabel>Possible date</ControlLabel>
                              {/* <FormControl
                                type="text"
                                value={this.state.ordercancelreason}
                                onChange={this.oncancelchnage}
                                name="ordercancelreason"
                                placeholder="Cancel Reason"
                              ></FormControl> */}

                              {/* <Datetime
                                  timeFormat={false}
                                  dateFormat="YYYY-MM-DD"
                                  inputProps={{ placeholder: "Expected Delivery Date" }}
                                  closeOnSelect={true}
                                  value={this.state.expectedDate}
                                  onChange={this.handleDateChange1}
                                /> */}
                              <FormGroup className="fl_datepicker">
                                <div
                                  style={{
                                    position: "relative",
                                  }}
                                >
                                  <FormControl
                                    style={{ margin: 0 }}
                                    value={`${this.state.datarange.start.format(
                                      "YYYY-MM-DD",
                                    )} - ${this.state.datarange.end.format(
                                      "YYYY-MM-DD",
                                    )}`}
                                    onClick={this.onToggle.bind(this)}
                                    placeholder="Date Range"
                                    type="text"
                                  />

                                  {this.state.isdatepickeron && (
                                    <DateRangePicker
                                      value={this.state.datarange}
                                      onSelect={this.onSelectnew}
                                      singleDateRange={true}
                                    />
                                  )}
                                </div>
                              </FormGroup>

                              {/* {this.state.ordercancelreasonError} */}
                            </FormGroup>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              onClick={this.submitSupplierModal.bind(this)}
                              bsStyle="success"
                              fill
                            >
                              Submit
                            </Button>
                            &nbsp;
                            <Button
                              onClick={this.closeCancelOrderModal.bind(this)}
                              bsStyle="info"
                              fill
                            >
                              Close
                            </Button>
                          </Modal.Footer>
                        </Modal>

                        <Modal
                          show={this.state.ridermodel}
                          onHide={() => this.setState({ ridermodel: true })}
                          bsSize="lg"
                        >
                          <Modal.Header>
                            <Modal.Title>Rider Details</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            {this.state.insuremeBannerText !== null && (
                              <Row>
                                <Col sm={12}>
                                  {this.state.insuremeBannerText}
                                </Col>
                              </Row>
                            )}
                            <FormGroup>
                              <Checkbox
                                number="56"
                                checked={this.state.is_currier}
                                onChange={(e) => this.isCurrier(e)}
                                label="Is Courier ?"
                              ></Checkbox>
                              {!this.state.is_currier ? (
                                <>
                                  <ControlLabel>Select Rider</ControlLabel>
                                  <Select
                                    className="react-select primary"
                                    classNamePrefix="react-select"
                                    placeholder="Rider"
                                    name="rider_info"
                                    value={this.state.rider_info}
                                    onChange={(value) =>
                                      this.setState({
                                        rider_info: value,
                                        rider_infoError: null,
                                      })
                                    }
                                    options={this.state.rider_data}
                                  />
                                  {/* {this.state.rider_infoError && (
                                    <div className="error">
                                      {this.state.rider_infoError}
                                    </div>
                                  )} */}
                                  {this.state.rider_infoError}
                                </>
                              ) : (
                                <>
                                  <ControlLabel>Courier Partner :</ControlLabel>
                                  <Select
                                    className="react-select primary"
                                    classNamePrefix="react-select"
                                    placeholder="Courier Partner"
                                    name="currier_id"
                                    value={this.state.currier_id}
                                    onChange={(value) =>
                                      this.setState({
                                        currier_id: value,
                                        currier_idError: null,
                                      })
                                    }
                                    options={this.state.currier_data}
                                  />
                                  {/* {this.state.currier_idError && (
                                    <div className="error">
                                      {this.state.currier_idError}
                                    </div>
                                  )} */}
                                  {this.state.currier_idError}
                                </>
                              )}

                              {this.state.is_currier ? (
                                <Row md={12}>
                                  <Col md={4}>
                                    <FormGroup
                                      style={{ margin: 0, marginTop: 10 }}
                                    >
                                      <ControlLabel>Tracking Id</ControlLabel>
                                      <FormControl
                                        type="text"
                                        name="tracking_id"
                                        value={this.state.tracking_id}
                                        onChange={this.onChangeTrack}
                                        placeholder="Enter tracking id"
                                      />
                                    </FormGroup>
                                  </Col>

                                  <Col md={4}>
                                    <FormGroup
                                      style={{ margin: 0, marginTop: 10 }}
                                    >
                                      <ControlLabel>Tracking Url</ControlLabel>
                                      <FormControl
                                        type="text"
                                        name="tracking_url"
                                        value={this.state.tracking_url}
                                        onChange={this.onChangeTrack}
                                        placeholder="Enter tracking url"
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col md={4}>
                                    <FormGroup
                                      style={{ margin: 0, marginTop: 10 }}
                                    >
                                      <ControlLabel>Tracking Note</ControlLabel>
                                      <FormControl
                                        type="text"
                                        name="tracking_note"
                                        value={this.state.tracking_note}
                                        onChange={this.onChangeTrack}
                                        placeholder="Enter tracking note"
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              ) : (
                                ""
                              )}
                            </FormGroup>

                            {this.state.htmlContent}
                            {this.state.order_info.map((s) => (
                              <React.Fragment>
                                <p
                                  className="custom-listing-style"
                                  onClick={() =>
                                    this.setState({
                                      viewMedDetails:
                                        !this.state.viewMedDetails,
                                    })
                                  }
                                >
                                  Order #{s.id}{" "}
                                  <b
                                    className={
                                      !!this.state.viewMedDetails
                                        ? "caret caret-down"
                                        : "caret rotate-180"
                                    }
                                  ></b>
                                </p>
                                <Collapse isOpened={this.state.viewMedDetails}>
                                  <div class="quality_div" responsive>
                                    <div class="half_div_1">
                                      {s.prescriptions.map((x) => {
                                        return (
                                          <a
                                            style={{
                                              display: "inline-block",
                                            }}
                                            href={x.prescription_file}
                                            target="_blank"
                                          >
                                            <img
                                              className="zoom"
                                              width="200px"
                                              src={x.prescription_file}
                                            />
                                          </a>
                                        );
                                      })}

                                      <label class="quality_heading">
                                        Prescription Text
                                      </label>

                                      <p style={{ fontSize: "12px" }}>
                                        {s.prescription_text}
                                      </p>
                                      <label class="quality_heading">
                                        Prescription Note
                                      </label>

                                      <p style={{ fontSize: "12px" }}>
                                        {s.prescription_note}
                                      </p>
                                    </div>
                                    <div class="half_div_2">
                                      <Table responsive>
                                        <thead>
                                          <tr>
                                            <th style={{ width: "80%" }}>
                                              medication Title
                                            </th>
                                            <th style={{ width: "20%" }}>
                                              quantity
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody style={{ fontSize: "12px" }}>
                                          {s.orderItems.map((x) => {
                                            return (
                                              <tr>
                                                <td>
                                                  {x.medication_title}(
                                                  {x.medication_itemcode})
                                                </td>
                                                <td>{x.quantity}</td>
                                              </tr>
                                            );
                                          })}
                                        </tbody>
                                      </Table>
                                    </div>

                                    <FormGroup>
                                      <Checkbox
                                        number={49 + s.id}
                                        checked={this.state.is_checked[s.id]}
                                        onChange={(e) =>
                                          this.qualitychecked(e, s.id)
                                        }
                                        label="Items checked against order & quantity packed"
                                      ></Checkbox>
                                    </FormGroup>
                                  </div>
                                </Collapse>
                              </React.Fragment>
                            ))}
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              onClick={this.warningWithConfirmAndChangeStatus.bind(
                                this,
                              )}
                              bsStyle="success"
                              fill
                              disabled={this.state.btn_disabled}
                            >
                              {this.state.btn_text}
                            </Button>
                            &nbsp;
                            <Button
                              onClick={this.closeriderdetailsModal.bind(this)}
                              bsStyle="info"
                              fill
                            >
                              Close
                            </Button>
                          </Modal.Footer>
                        </Modal>

                        <Modal
                          show={this.state.showOutOfStock}
                          onHide={() => this.setState({ showOutOfStock: true })}
                        >
                          <Modal.Header>
                            <Modal.Title>Medicine Out of Stock</Modal.Title>
                          </Modal.Header>
                          <Modal.Body
                            style={{
                              maxHeight: "calc(100vh - 170px)",
                              overflow: "auto",
                            }}
                          >
                            <Table responsive>
                              <thead>
                                <tr>
                                  <th>Order Id</th>
                                  <th>Code</th>
                                  <th>Medicine</th>
                                  <th>Order Quantity</th>
                                  <th>Available Quantity</th>
                                </tr>
                              </thead>
                              <tbody style={{ fontSize: "14px" }}>
                                {this.state.medicationListing.map((x) => {
                                  return (
                                    <tr>
                                      <td>{x.orderId}</td>
                                      <td>{x.code}</td>
                                      <td>{x.medicine}</td>
                                      <td>{x.required}</td>
                                      <td>{x.actual_avail}</td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </Table>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              bsStyle="info"
                              fill
                              onClick={() =>
                                this.setState({
                                  showOutOfStock: false,
                                  selected_id: [],
                                })
                              }
                            >
                              Close
                            </Button>
                          </Modal.Footer>
                        </Modal>
                      </Col>
                    </Row>
                  </React.Fragment>
                }
              />
            </Col>
          </Row>
        </Grid>
        <OrderSelectionModal
          show={this.state.showModal}
          onClose={this.closeModal}
          onPickUp={this.goToPickUp}
          onOrder={this.goToOrder}
        />
        {this.state.isLoading ? <ScreenLoader /> : ""}
      </div>
    );
  }
}
export default viewOrder;
